import React, { useState, useEffect, useMemo, useContext, useRef } from "react";
import html2pdf from 'html2pdf.js';;
import { connect, useDispatch } from "react-redux";
import { Container, Card, Row, Col, Form, Table, Button, ListGroup } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Icon from "react-icons-kit";
import {ic_delete_outline} from "react-icons-kit/md";
import {ic_chevron_left} from "react-icons-kit/md/ic_chevron_left";
import {ic_chevron_right} from "react-icons-kit/md/ic_chevron_right";
import {ic_phone} from 'react-icons-kit/md/ic_phone'
import { Link, useParams, Navigate } from "react-router-dom";
import { ic_arrow_back } from "react-icons-kit/md";
import MainWrapper from "../../MainWrapper";
import PricingContract from "../customer/models/PricingContract";
import { 
  CUSTOMER_LIST_REQUEST,
  CUSTOMER_UNIT_DETAIL_REQUEST,
  CUSTOMER_ORDER_DETAIL_REQUEST,
  RESET_CUSTOMER_ORDER_DETAILS,
  CUSTOMER_STATE_CHANGE,
  SAVE_CUSTOMER_CONTRACT_DETAILS_REQUEST,
  CUSTOMER_ORDER_UNIT_CHANGE_REQUEST,
  CUSTOMER_ORDER_UNIT_TYPE_CHANGE_REQUEST,
  CUSTOMER_ORDER_RESCHEDULE_REQUEST,
  CUSTOMER_ORDER_RESCHEDULE_DATE_REQUEST,
  CUSTOMER_ORDER_ADD_ON_DETAILS_REQUEST,
  CUSTOMER_ORDER_ADDON_SAVE_REQUEST,
  GET_SHORTAGE_REASON_REQUEST,
  SAVE_ORDER_SHORTAGE_DETAIL_REQUEST,
  UPDATE_SHORTAGE_REASON_REQUEST,
  GET_QUALITY_REASON_REQUEST,
  GET_QUALITY_ORDER_REQUEST,
  UPDATE_QUALITY_REASON_REQUEST,
  UPDATE_QUALITY_DETAIL_REQUEST,
  CUSTOMER_ORDER_CANCEL_REQUEST,
  UPDATE_CHILD_REASON_REQUEST
 } from "../../../_utils/constants/Customer";
 import {
  CUSTOMER_ORDER_MATERIAL_REQUEST,
  CUSTOMER_ORDER_INSTALLATION_REQUEST,
  CUSTOMER_ORDER_MATERIAL_DELETE_REQUEST,
  CUSTOMER_ORDER_LABOR_DELETE_REQUEST,
  SAVE_QUALITY_ORDER_DETAILS_REQUEST,
  SAVE_ORDER_QUALITY_DETAIL_REQUEST,
  UPDATE_RESCHEDULE_DATA_REQUEST,
  SUB_ORDER_DELETE_REQUEST,
  UPDATE_ORDER_DETAIL_REQUEST
 } from "../../../_utils/constants/PricingContract";
import { useNavigate } from "react-router-dom";
import ConfirmDelete from "../../elements/ConfirmDelete";
import Input from "../../elements/CustomInput";
import { toast } from 'react-toastify';
import ChangeJob from "./models/ChangeJob";
import {Context} from "../../../App";
import Select from "../../elements/CustomSelect";
import ConfirmModal from "../admin/customerapproval/ConfirmModal";
import {
  CARPET_ID_DB,
  SHEET_VINYL_ID_DB,
  VINYL_PLANK_ID_DB,
  WALLBASE_ID_DB,
  INSTALLATION_ACCESSORIES_ID_DB,
  TRANSITION_ID_DB,
} from "../../../_utils/constants/ProductCatalog";
import {
  applySnapToGridForRolledGoods,
} from "../../../_utils/helpers";

const OrderConfirmation = ({
  auth: { auth, isAuthenticated },
	customerInfo: { customerList, customerOrderDetails, customerSaveOrderDetails, customerSaveContractDetails, isLoading, errors, isDateRescheduled, orderRescheduledDetails, orderAddOnDetails, saveOrderAddOnDetails, shortageReason, saveOrderShortage, updateShortageReason, qualityReasons, saveOrderQualityDetailData, OrderQualityDetail, updatedQualityReason, updatedQualityDetail, isOrderLoading, isCustomerOrderDeleted },
  pricingContract: { orderMaterialData, orderInstallationData, deletedOrderMaterialData, deletedOrderLaborData, isProcessing, updatedReschedule, rescheduleError, subOrderDeleted, subOrderError, isOrderUdpated, rescheduleRes },
  fetchOrderInstallationDetail,
  fetchCustomerList,
	saveCustomerOrderDetails,
  changeReducerState,
  fetchOrderInstallationMaterial,
  fetchOrderInstallationOrder,
  saveCustomerOrderDetailsForPricingContract,
  deleteOrderMaterialData,
  deleteOrderLaborData,
  saveCustomerOrderUnitId,
  saveCustomerOrderUnitTypeId,
  saveCustomerOrderRescheduleData,
  fetchCustomerOrderRescheduledData,
  fetchCustomerOrderAddOnDetails,
  saveCustomerOrderAddOnDetails,
  getShortageReasonRequest,
  saveOrderShortageRequest,
  updateShortageReasonRequest,
  getQualityReasonRequest,
  saveOrderQualityDetailRequest,
  saveQualityOrderDetail,
  fetchQualityOrderDetail,
  updateQualityReason,
  updateQualityDetail,
  customerOrderCancel,
  updateChildReasonRequest,
  saveRescheduleOrderRequest,
  deleteSubOrder,
  updateOrderDetail
}) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {pushervalue} = useContext(Context);
  // states declaration
  // Support both URL formats for the order detail route:
  //   /place-order/order-confirmation/:contactInfoId/:unitId/:jobNum
  //   /place-order/order-confirmation/contactInfoId=:contactInfoId/unitId=:unitId/jobNum=:jobNum
  // React Router v6 cannot capture a param that isn't a full path segment, so
  // the prefixed format lands here as e.g. jobNum="jobNum=123". Strip the
  // "<key>=" prefix so downstream logic always sees clean values.
  const routeParams = useParams()
  const stripParamPrefix = (value, prefix) =>
    (typeof value === 'string' && value.startsWith(prefix)) ? value.slice(prefix.length) : value;
  const contactInfoId = stripParamPrefix(routeParams.contactInfoId, 'contactInfoId=')
  const unitId = stripParamPrefix(routeParams.unitId, 'unitId=')
  let jobNum = stripParamPrefix(routeParams.jobNum, 'jobNum=')
  const parsedJobNum = jobNum;
  const parseJobId = (value) => String(value).replace(/^[dD]-/, '');
  jobNum = parseJobId(jobNum);
  const [pricingContractModalOpen, setPricingContractModalOpen] = useState(false)
  const [laborContractModalOpen, setLaborContractModalOpen] = useState(false)
  const [materialContractModalOpen, setMaterialContractModalOpen] = useState(false)
  const [customerData, setCustomerData] = useState()
  const [customerOrderData, setCustomerOrderData] = useState()
  const [materialListData, setMaterialListData] = useState()
  const [orderInstallationListData, setOrderInstallationListData] = useState()
  const [state, setState] = useState({
    "newUnitId": "",
    "newUnitTypeId": "",
    "description": "",
    "internalNotes": "",
    "installerInstructions": "",
    "PurchaseOrder": "",
    "TotalTax": "",
  })
  const [stateLaborFilter, setStateLaborFilter] = useState({
		"laborName": "",
		"storeId": "",
		"ContactInfoId": "",
		"grpPricingContractId": "",
		"productTypeId": 0,
		"productStructureId": 0,
		"laborCategoryId": 0,
		"unitId": 0,
		"currentCost": 0,
		"futureCost1": 0,
		"increaseDate": "",
		"sortOn": "",
	});
  const [lsUpdate, setLsUpdate] = useState(false)
  const [lsLaborUpdate, setLsLaborUpdate] = useState(false)
  const [lsLaborMaterialUpdate, setLsLaborMaterialUpdate] = useState(false)

  const [orderInstallationCarpetData, setOrderInstallationCarpetData] = useState()
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false)
  const [deleteOrderData, setDeleteOrderData] = useState()
  const [deleteOrder, setDeleteOrder] = useState()
  const [totalMaterialUnitPrice, setTotalMaterialUnitPrice] = useState()
  const [totalMaterialLinePrice, setTotalMaterialLinePrice] = useState()
  const [totalMaterialJobCost, setTotalMaterialJobCost] = useState(0.00)
  const [totalMaterialProfit, setTotalMaterialProfit] = useState(0.00)
  const [totalMaterialGPM, setTotalMaterialGPM] = useState(0.00)
  const [totalLaborJobCost, setTotalLaborJobCost] = useState(0.00)
  const [totalLaborProfit, setTotalLaborProfit] = useState(0.00)
  const [totalLaborGPM, setTotalLaborGPM] = useState(0.00)
  const [totalLaborUnitPrice, setTotalLaborUnitPrice] = useState()
  const [totalLaborLinePrice, setTotalLaborLinePrice] = useState()
  const [totalLaborOrgUnitPrice, setTotalLaborOrgUnitPrice] = useState()
  const [totalLaborOrgLinePrice, setTotalLaborOrgLinePrice] = useState()
  const [orderTotal, setOrderTotal] = useState()
  const [checkOrder, setCheckOrder] = useState(false)
  const [isChangeJob, setIsChangeJob] = useState(false)
  const [startDate, setStartDate] = useState()
  const [rescheduleData, setRescheduleData] = useState({
    'RescheduleChoicesId': '',
    'changeJobNotes': ''
  })
  // const [ selectedCheckbox, setSelectedCheckbox] = useState([])
  const [ orderShortageList, setOrderShortageList ] = useState([])
  const [ changeJobHeader, setChangeJobHeader ] = useState('Change Job')
  const [ pendingShortageReasons, setPendingShortageReasons ] = useState([])
  const [ addOnData, setAddOnData ] = useState({
    'approvedBy': '',
    'description': ''
  })
  const [ isStateChanged, setIsStateChanged ] = useState(false)
  const [orderingUrl, setIsOrderingUrl] = useState();
  const [processStart, setProcessStart] = useState(false);
  const qualityOrderData = JSON.parse(localStorage.getItem('quality-order'))
  const [ pendingQualityReasons, setPendingQualityReasons ] = useState([])
  const [isQualityPlaced, setIsQualityPlaced] = useState(false)
  // const [ selectedQualityCheckbox, setSelectedQualityCheckbox] = useState([])
  const [createdDate, setCreatedDate] = useState("")
  const [createdTime, setCreatedTime] = useState("")
  const [isAddOnSubmitted, setIsAddOnSubmitted] = useState(false)
  const [rescheduleAddonsData, setRescheduleAddonsData] = useState({})
  const [rescheduleShortageData, setRescheduleShortageData] = useState({})
  const [rescheduleQualityData, setRescheduleQualityData] = useState({})
  const [deletePropertyModalOpen, setDeletePropertyModalOpen] = useState(false);
  const [deletePropertyData, setDeletePropertyData] = useState({});
  const [ orderAddonsList, setOrderAddonsList ] = useState([])
  const [ orderQualityList, setOrderQualityList ] = useState([])
  // const [orderDetailUpdateMessage, setOrderDetailUpdateMessage] = useState('')
  const [localStorageData, setLocalStorageData] = useState({})

  useEffect(() => {
		if (!isAuthenticated) {
			navigate("/login")
		}
	}, [auth, isAuthenticated])

  // function to check if order generated or is selected
  const orderedPlaced = () => {
    let fromExistingOrder = localStorage.getItem('Existing_Orders');
    if (fromExistingOrder === 'true') {
      return true
    } else {
      return false
    }
  }

  // function to fetch quality order data
  const handleQualityOrderData = () => {
    if (qualityOrderData) {
      let formData = new FormData();
      formData.append('OrderInstallationDetail', qualityOrderData?.OrderInstallationDetail)
      formData.append('AddonItems', qualityOrderData?.AddonItems)
      fetchQualityOrderDetail(auth[0].token, formData)
    }
  }

  // handle placed order
  const qualityJobNo = () => {
    return JSON.parse(localStorage.getItem('quality-JobNum'))
  }

  const isOrderDeleted = () => {
    if (typeof parsedJobNum === "string" && (parsedJobNum.includes("D-") || parsedJobNum.includes("d-"))) {
      return true; // Returns true if the string contains "-A".
    }
    return false;
  }

  // handle quality placed
  const handlePlacedQuality = () => {
    if (typeof jobNum === "string" && (jobNum.includes("-Q") || jobNum.includes("-S") || jobNum.includes("-CO"))) {
      setIsQualityPlaced(true)
      return true; // Returns true if the string contains "-A".
    }
    setIsQualityPlaced(false)
    return false;
  }

  // handle formatting of date
  const handleFormatDate = (installationDate) => {
    const dateObj = new Date(installationDate);
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const formattedDate = `${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}-${year}`;
    return formattedDate;
  }

  // parse the date | database to frontend
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${month}.${day}.${year}`;
  };

  // handle created data and time
  const handleOrderedDetails = () => {
    let existing_Orders_value = JSON.parse(localStorage.getItem('Existing_Orders_value'))
    if (existing_Orders_value) {
      let dateObject = new Date(existing_Orders_value?.CreatedOn)
      let formattedDate = dateObject.toISOString().split("T")[0]
      let formattedTime = dateObject.toTimeString().split(" ")[0]
      setCreatedDate(handleFormatDate(formattedDate));
      setCreatedTime(formattedTime);
    }
  }

  // check if any order installation detail has IsDeleted = true
  const hasDeletedItems = useMemo(() => {
    if (!customerOrderDetails || customerOrderDetails.length === 0) {
      return false;
    }

    return customerOrderDetails.some(order =>
      order?.orderInstallationDetails?.IsDeleted === true
    );
  }, [customerOrderDetails]);

  // check the current BC status of the order
  const isOrderReleased = useMemo(() => { // not need for now. so returned false 
    const existingOrderValue = JSON.parse(localStorage.getItem('Existing_Orders_value') || '{}');

    if(!existingOrderValue || !existingOrderValue?.BCStatus) return false;
    
    if(typeof existingOrderValue.BCStatus !== 'string') return false;
    
    // return existingOrderValue.BCStatus.toLowerCase() === "released";
    return false;
  }, [])


  // Previous/Next navigation across the orders list the user came from.
  // The list is persisted to sessionStorage when an order is opened from the
  // Existing Orders listing, so it only applies for the current session.
  const orderNav = useMemo(() => {
    let navState;
    try {
      navState = JSON.parse(sessionStorage.getItem('Existing_Orders_Nav'));
    } catch (e) {
      navState = null;
    }
    const list = navState && Array.isArray(navState.list) ? navState.list : [];
    if (list.length === 0) return { show: false, prev: null, next: null };
    const currentIndex = list.findIndex(item => String(item?.JobNo) === String(jobNum));
    if (currentIndex === -1) return { show: false, prev: null, next: null };
    return {
      show: true,
      prev: currentIndex > 0 ? list[currentIndex - 1] : null,
      next: currentIndex < list.length - 1 ? list[currentIndex + 1] : null,
    };
  }, [jobNum]);

  // navigate to an adjacent order, replicating the localStorage setup that a
  // normal click from the Existing Orders listing performs
  const goToOrder = (targetOrder) => {
    if (!targetOrder) return;
    let isDeleted = false;
    try {
      const navState = JSON.parse(sessionStorage.getItem('Existing_Orders_Nav'));
      isDeleted = !!(navState && navState.isDeletedView);
    } catch (e) {
      isDeleted = false;
    }
    localStorage.setItem('Existing_Orders', JSON.stringify(true));
    localStorage.setItem('Existing-Orders-Page', JSON.stringify(true));
    localStorage.setItem('quality-JobNum', JSON.stringify(targetOrder?.JobNo));
    localStorage.setItem('quality-UnitId', JSON.stringify(targetOrder?.UnitId));
    localStorage.setItem('Existing_Orders_value', JSON.stringify(targetOrder || null));
    navigate(`/place-order/order-confirmation/contactInfoId=${targetOrder?.ContactInfoId}/unitId=${targetOrder?.UnitId}/jobNum=${isDeleted ? 'D-' : ''}${targetOrder?.JobNo}`);
    // navigate(`/place-order/order-confirmation/${targetOrder?.ContactInfoId}/${targetOrder?.UnitId}/${isDeleted ? 'D-' : ''}${targetOrder?.JobNo}`);
  };

  // function to call customer detail api
	useEffect(() => {
		if (isAuthenticated) {
      fetchCustomerList(auth[0].token, "asc", 1, 1, { 'contactInfoId': contactInfoId }, auth[0].userId, false, false, false)
      getShortageReasonRequest(auth[0].token, '')
      let tmpIsDeleted = isOrderDeleted()
      fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
      if (!JSON.parse(localStorage.getItem('isQuality'))) {
        fetchOrderInstallationMaterial(auth[0].token, jobNum)
        fetchOrderInstallationOrder(auth[0].token, jobNum)
      }
      handlePlacedQuality()
      handleOrderedDetails()
		}
		if (!isAuthenticated) return <Navigate to="/login" />
	}, [auth, isAuthenticated]);

  // function called to modify order listing
	useEffect(() => {
		localStorage.setItem('Order-Listing', 'on');
	}, [])

  // for update the shortage reason
  useEffect(() => {
    if (updateShortageReason && updateShortageReason.length > 0 && jobNum && !JSON.parse(localStorage.getItem('isQuality'))) {
      let tmpIsDeleted = isOrderDeleted()
      fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
    }
    handleQualityOrderData()
  },[updateShortageReason])

  // for update the Quality reason
  useMemo(() => {
    if (updatedQualityReason && updatedQualityReason.length > 0 && jobNum && !JSON.parse(localStorage.getItem('isQuality'))) {
      let tmpIsDeleted = isOrderDeleted()
      fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
    }
    handleQualityOrderData()
  },[updatedQualityReason])

  // for update the quality detail
  useEffect(() => {
    if (updatedQualityDetail && updatedQualityDetail.length > 0 && jobNum && !JSON.parse(localStorage.getItem('isQuality'))) {
      let tmpIsDeleted = isOrderDeleted()
      fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
    }
    handleQualityOrderData()
  },[updatedQualityDetail])

  // function to handle view from existing order
  const handleExistingOrder = () => {
    let fromExistingOrder = localStorage.getItem('Existing_Orders');
    if (fromExistingOrder === 'true') {
      setCheckOrder(true)
    } else {
      setCheckOrder(false)
    }
  }

    // build auto-description from material list based on product structure and sub-structure
  const computeAutoDescription = (materialList) => {
    if (!materialList || materialList.length === 0) return '';
    const seen = new Set();
    const parts = [];
    const sortedData = materialList.sort(
      (a, b) => a.productStructureId - b.productStructureId
    );
    sortedData.forEach(item => {
      const psId = parseInt(item.productStructureId, 10);
      if (psId === CARPET_ID_DB) {
        if (!seen.has('Carpet')) { seen.add('Carpet'); parts.push('Carpet'); }
      } else if (psId === VINYL_PLANK_ID_DB) {
        if (!seen.has('Vinyl Plank')) { seen.add('Vinyl Plank'); parts.push('Vinyl Plank'); }
      } else if (psId === SHEET_VINYL_ID_DB) {
        if (!seen.has('Sheet Vinyl')) { seen.add('Sheet Vinyl'); parts.push('Sheet Vinyl'); }
      } else if (psId === INSTALLATION_ACCESSORIES_ID_DB) {
        const sub = (item.productSubStructureName || '').trim();
        if (sub && !seen.has(sub)) { seen.add(sub); parts.push(sub); }
      } else if (psId === WALLBASE_ID_DB) {
        const sub = (item.productSubStructureName || '').toLowerCase().trim();
        let label;
        if (sub.includes('wall base') || sub.includes('wood base')) {
          label = 'Wood Base';
        } else if (sub.includes('quarter round')) {
          label = 'Quarter Round';
        } else {
          label = 'Cove Base';
        }
        if (!seen.has(label)) { seen.add(label); parts.push(label); }
      }
    });
    return parts.join(', ');
  };


  useEffect(() => {
    handleExistingOrder()
  }, [checkOrder, localStorage.getItem('Existing_Orders')])

  // function to manage customer list data
  useMemo(() => {
    if(customerList.length > 0) {
      setCustomerData(customerList)
      setStateLaborFilter({
        ...stateLaborFilter,
        "storeId": customerList[0].storeId,
        "ContactInfoId": contactInfoId
      })
    }
  }, [customerList])

  // function to check if customer order deleted
  useEffect(() => {
    if (isCustomerOrderDeleted && isCustomerOrderDeleted.length > 0) {
      setIsChangeJob(false)
      toast.success(isCustomerOrderDeleted?.[0])
      setTimeout(() => {
        navigate("/existing-orders")
      }, 5000);
      changeReducerState()
    }
  }, [isCustomerOrderDeleted])

  // handle quality status list data
  const qualityOrderedStatusList = useMemo(() => {
    let qualityStatusData = [{ value: "Open", label: "Open" }, { value: "Closed", label: "Closed" }];
    return qualityStatusData
  }, [customerOrderDetails])

  // handle sorted data for reschedule
  const sortedDetails = customerOrderDetails.map((order) => {
    const sortedHistory = order.rescheduleHistory
      ? [...order.rescheduleHistory].sort(
          (a, b) => b.orderRescheduleHistoryId - a.orderRescheduleHistoryId
        )
      : [];

    return {
      ...order,
      rescheduleHistory: sortedHistory,
    }
  })

  // function to manage customer order details
  useMemo(() => {
    if(customerOrderDetails) {
       // Get the parent jobNo as fallback
      const parentJobNo = customerOrderDetails[0]?.orderInstallationDetails?.jobNo || jobNum;

      // Transform shortage data to include jobNo at top level
      const transformedShortageList = customerOrderDetails[0]?.orderShortage?.map(item => ({
        ...item,
        jobNo: item.orderShortageDetail?.originalJobNo || parentJobNo
      })) || [];

      // Transform quality data to include jobNo at top level
      const transformedQualityList = customerOrderDetails[0]?.orderQuality?.map(item => ({
        ...item,
        jobNo: item.orderQualityDetail?.originalJobNo || parentJobNo
      })) || [];

      setOrderShortageList(transformedShortageList)
      // setOrderShortageList(customerOrderDetails ? customerOrderDetails[0]?.orderShortage : [])
      setOrderAddonsList(customerOrderDetails[0]?.orderAddOns || [])
      setOrderQualityList(transformedQualityList)
      // commented for sorting reschedule history
      // setCustomerOrderData(customerOrderDetails)
      setCustomerOrderData(sortedDetails)
      let tempData = qualityOrderData?.OrderInstallationDetail && JSON.parse(localStorage.getItem('isQuality')) ? JSON.parse(qualityOrderData?.OrderInstallationDetail) : null
      customerOrderDetails.map(data => {
        const autoDesc = computeAutoDescription(materialListData);
        setState({
          "newUnitId": data?.orderInstallationDetails?.UnitName ? data?.orderInstallationDetails?.UnitName : "",
          "newUnitTypeId": data?.orderInstallationDetails?.UnitTypeName ? data?.orderInstallationDetails?.UnitTypeName : "",
          "description": data?.orderInstallationDetails?.Description ? data?.orderInstallationDetails?.Description : autoDesc,
          "internalNotes": data?.orderInstallationDetails?.InternalNotes ? data?.orderInstallationDetails?.InternalNotes : "",
          "installerInstructions": tempData?.Instruction ? tempData?.Instruction : (data?.orderInstallationDetails?.InstallerInstruction ? data?.orderInstallationDetails?.InstallerInstruction : data?.orderInstallationDetails?.Instruction),
          "PurchaseOrder": data?.orderInstallationDetails?.PurchaseOrder ? data?.orderInstallationDetails?.PurchaseOrder : "",
          "TotalTax": data?.orderInstallationDetails?.TotalTax ? data?.orderInstallationDetails?.TotalTax : "",
        })
        let tmpOrderVariant = data?.orderInstallationDetails?.VariantId ?? 0;
        localStorage.setItem('order-VariantId',tmpOrderVariant)
      })
    }
  }, [customerOrderDetails])

  // handle odor condition
  const handleOdorCondition = (tempList) => {
    if (tempList && tempList.length > 0) {
      tempList.map(data => {
        if (data.labor?.toLowerCase() === 'odor b gone application' || data.laborName?.toLowerCase() === 'odor b gone application' ? true : false) {
          data.quantity = 1.00
          data.linePrice = parseFloat(1.00 * data.unitPrice).toFixed(2)
        }
      })
    }
  }

  // handle listing modification
  const roundSpecificKeys = (data, keysToRound = ["quantity", "unitPrice", "linePrice"]) => {
    return data.map(item =>
      Object.fromEntries(
        Object.entries(item).map(([key, value]) => {
          if (keysToRound.includes(key) && typeof value === "number") {
            return [key, value.toFixed(2)]
          }
          return [key, value]
        })
      )
    )
  }

  useEffect(() => {
    if (!parseInt(jobNum) && OrderQualityDetail && OrderQualityDetail.length > 0 && JSON.parse(localStorage.getItem('isQuality'))) {
      let arr1 = OrderQualityDetail.map(item => [...item.productData, ...item.materialData]);
      let arr2 = OrderQualityDetail.map(item => [...item.laborData]);
      let tempList = roundSpecificKeys(arr1.flat())
      let tempList2 = roundSpecificKeys(arr2.flat())
      setMaterialListData(tempList)
      handleOdorCondition(tempList2)
      setOrderInstallationListData(tempList2)
      let tempData = JSON.parse(qualityOrderData.OrderInstallationDetail)
      if (customerOrderData && customerOrderData.length > 0) {
        customerOrderData.map(data => {
          data.orderInstallationDetails.MeasureImagePng = tempData.FloorPlan ? tempData.FloorPlan : data.orderInstallationDetails.MeasureImagePng,
          data.orderInstallationDetails.InstallationDate = tempData.InstallationDate ? tempData.InstallationDate : data.orderInstallationDetails.InstallationDate,
          data.orderInstallationDetails.Email = tempData.Email ? tempData.Email : data.orderInstallationDetails.Email,
          data.orderInstallationDetails.FullName = tempData.FullName ? tempData.FullName : data.orderInstallationDetails.FullName,
          data.orderInstallationDetails.Instruction = tempData.Instruction ? tempData.Instruction : data.orderInstallationDetails.Instruction,
          data.orderInstallationDetails.Occupaied = tempData.Occupaied ? tempData.Occupaied : data.orderInstallationDetails.Occupaied,
          data.orderInstallationDetails.PhoneNo = tempData.PhoneNo ? tempData.PhoneNo : data.orderInstallationDetails.PhoneNo,
          data.orderInstallationDetails.PurchaseOrder = tempData.PurchaseOrder ? tempData.PurchaseOrder : data.orderInstallationDetails.PurchaseOrder,
          data.orderInstallationDetails.UnitId = tempData.unitId ? tempData.unitId : data.orderInstallationDetails.UnitId
        })
      }
    }
  }, [OrderQualityDetail])

  useEffect(() => {
    if(saveOrderQualityDetailData?.result && saveOrderQualityDetailData?.result?.length > 0 && JSON.parse(localStorage.getItem('isQuality'))) {
      if (saveOrderQualityDetailData?.result[0] === 'Quality order saved successfully') {
        // toast.success(saveOrderQualityDetailData?.result[0])
        localStorage.setItem('Existing_Orders', JSON.parse(true))
        localStorage.setItem('Existing-Orders-Page', JSON.parse(true))
        localStorage.setItem('isQuality', false)
        setTimeout( () => {
          // navigate(`/place-order/order-confirmation/${localStorage.getItem("place-order-contactInfoId")}/${parseInt(JSON.parse(localStorage.getItem('quality-UnitId')))}/${parseInt(JSON.parse(localStorage.getItem('quality-JobNum')))}`)
          navigate(`/place-order/order-confirmation/contactInfoId=${localStorage.getItem("place-order-contactInfoId")}/unitId=${parseInt(JSON.parse(localStorage.getItem('quality-UnitId')))}/jobNum=${parseInt(JSON.parse(localStorage.getItem('quality-JobNum')))}`)
          setCheckOrder(false)
          let tmpIsDeleted = isOrderDeleted()
          fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
          fetchCustomerList(auth[0].token, "asc", 1, 1, { 'contactInfoId': contactInfoId }, auth[0].userId, false, false, false)
          getShortageReasonRequest(auth[0].token, '')
          fetchOrderInstallationMaterial(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo())
          fetchOrderInstallationOrder(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo())
        }, 1000)
      }
    }
  }, [saveOrderQualityDetailData])

  // handle click make change
  const handleMakeChangeClose = () => {
    setIsChangeJob(false)
    setStartDate()
    setChangeJobHeader('Change Job')
    setRescheduleData({
      'RescheduleChoicesId': '',
      'changeJobNotes': ''
    })
    setAddOnData({
      'approvedBy': '',
      'description': ''
    })
    fetchOrderInstallationMaterial(auth[0].token, jobNum)
    fetchOrderInstallationOrder(auth[0].token, jobNum)
  }

  // handle click make change
  const handleMakeChangeModalOpen = () => {
    localStorage.removeItem("selectedAllCarpetData"); localStorage.removeItem("selectedAllLaborMaterialCarpetData"); localStorage.removeItem("copySelectedLaborList")
    setLocalStorageData({})
    setIsChangeJob(true)
  }

  // handle click make change
  const handleMakeChangeClick = () => {
    handleMakeChangeModalOpen()
  }

  useEffect(() => {
    if (changeJobHeader === 'Reschedule' && (isDateRescheduled[0] === 'saved' || isDateRescheduled[0].toLowerCase().startsWith("saved"))) {
      let tmpIsDeleted = isOrderDeleted()
      fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
      toast.success(isDateRescheduled[0])
      handleMakeChangeClose()
      setIsChangeJob(false)
    } else if (changeJobHeader === 'Add On' && isDateRescheduled[0] === 'saved') {
      let tmpIsDeleted = isOrderDeleted()
      fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
      toast.success(isDateRescheduled[0])
      handleMakeChangeClose()
      setIsChangeJob(false)
    } else if (changeJobHeader === 'Reschedule' && isDateRescheduled[0]) {
      toast.error(isDateRescheduled[0])
    }
  }, [isDateRescheduled])

  // handle reschedule date edit case
  // useEffect(() => {
  //   if (orderRescheduledDetails && orderRescheduledDetails[0] && orderRescheduledDetails.length > 0) {
      // setRescheduleData({
      //   'RescheduleChoicesId': orderRescheduledDetails[0].reason,
      //   'changeJobNotes': orderRescheduledDetails[0].note
      // })
      // setStartDate(orderRescheduledDetails[0].orderInstallationDate)
  //   }
  // }, [orderRescheduledDetails])
    
  //reset all state
  const resetState = () => {
    setMaterialContractModalOpen()
    setCustomerData()
    setCustomerOrderData()
    setMaterialListData()
    setOrderInstallationListData()
    setState({
      "newUnitId": "",
      "newUnitTypeId": "",
      "description": "",
      "internalNotes": "",
      "installerInstructions": "",
      "PurchaseOrder": "",
      "TotalTax": "",
    })
    setStateLaborFilter({
      "laborName": "",
      "storeId": "",
      "ContactInfoId": "",
      "grpPricingContractId": "",
      "productTypeId": 0,
      "productStructureId": 0,
      "laborCategoryId": 0,
      "unitId": 0,
      "currentCost": 0,
      "futureCost1": 0,
      "increaseDate": "",
      "sortOn": "",
    })
    setOrderInstallationCarpetData()
    setConfirmDeleteModal()
    setDeleteOrderData()
    setDeleteOrder()
    setTotalMaterialUnitPrice()
    setTotalMaterialLinePrice()
    setTotalLaborUnitPrice()
    setTotalLaborLinePrice()
    setOrderTotal()
  }

  // function called to save updated listing for material and labor
  const handleMaterialLaborListingUpdate = () => {
    let productList = []
    let materialList = []
    let laborList = []
    if(materialListData && materialListData.length > 0) {
      const sortedMaterials = materialListData.sort((a, b) => a.productStructureId - b.productStructureId);
      sortedMaterials
      .filter(({ quantity }) => quantity !== "" && quantity != null && quantity !== undefined)
      .map(data => {
        if(data.orderProductId) {
          productList.push({
            ProductId: data.productId,
            Quantity: parseFloat(data.quantity),
            GPM: parseFloat(data.gpm),
            LinePrice: parseFloat(data.linePrice),
            OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
            CreatedBy: parseFloat(auth[0].userId),
            UnitPrice: data.unitPrice ? parseFloat(data.unitPrice) : data.price ? parseFloat(data.price) : 0.00,
            ProductStructureId: data.productStructureId
          })
        }
        if(data.orderMaterialId) {
          materialList.push({
            MaterialId: parseFloat(data.materialId),
            Product: parseFloat(data.productId),
            Quantity: parseFloat(data.quantity),
            GPM: parseFloat(data.gpm),
            LinePrice: parseFloat(data.linePrice),
            OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
            CreatedBy: parseFloat(auth[0].userId),
            UnitPrice: data.unitPrice ? parseFloat(data.unitPrice) : data.price ? parseFloat(data.price) : 0.00,
            ProductStructureId: data.productStructureId
          })
        }
        if(data.productId && !data.orderProductId && !data.orderMaterialId) {
          productList.push({
            ProductId: data.productId,
            Quantity: parseFloat(data.quantity),
            GPM: parseFloat(data.gpm),
            LinePrice: parseFloat(data.linePrice),
            OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
            CreatedBy: parseFloat(auth[0].userId),
            UnitPrice: data.unitPrice ? parseFloat(data.unitPrice) : data.price ? parseFloat(data.price) : 0.00,
            ProductStructureId: data.productStructureId
          })
        }
      })
    }
    if(orderInstallationListData && orderInstallationListData.length > 0) {
      const sortedLabors = orderInstallationListData.sort((a, b) => a.productStructureId - b.productStructureId);
      // sortedLabors.filter(data => data.quantity !== "" && data.quantity !== null && data.quantity !== undefined).map(data => {
      //   laborList.push({
      //     LaborItemId: data.laborItemId,
      //     OrderLaborId: data.orderLaborId,
      //     LaborId: data.laborId,
      //     Quantity: data.quantity,
      //     GPM: data.gpm,
      //     LinePrice: data.linePrice,
      //     OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
      //     CreatedBy: parseFloat(auth[0].userId),
      //     UnitPrice: data.unitPrice ? parseFloat(data.unitPrice) : data.price ? parseFloat(data.price) : 0.00,
      //     ProductStructureId: data.productStructureId
      //   })
      // })
      const orderInstallationDetailId = customerOrderData?.[0]?.orderInstallationDetails?.OrderInstallationDetailId;
      const createdBy = Number(auth?.[0]?.userId) || 0;
      laborList = sortedLabors
        .filter(({ quantity }) => quantity !== "" && quantity != null && quantity !== undefined)
        .map((data) => ({
          LaborItemId: data.laborItemId,
          OrderLaborId: data.orderLaborId,
          LaborId: data.laborId,
          Quantity: data.quantity,
          GPM: data.gpm,
          LinePrice: data.linePrice,
          OrderInstallationDetailId: orderInstallationDetailId,
          CreatedBy: createdBy,
          UnitPrice: Number(data.unitPrice ?? data.price ?? 0),
          ProductStructureId: data.productStructureId,
        }));
    }
    let payload = {
      OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
      OrderMaterial: materialList,
      ProductOrder: productList,
      LaborOrder: laborList
    }
    // if(materialList.length > 0 || productList.length > 0 || laborList.length > 0){
    saveCustomerOrderDetailsForPricingContract(auth[0].token, payload) //api saveOrder
    // }
  }

  // handle save order details api response
  useMemo(() => {
    if(customerSaveOrderDetails.length > 0 && customerSaveOrderDetails[0] === "save") {
      handleMaterialLaborListingUpdate()
    }
    if(customerSaveOrderDetails.length > 0 && customerSaveOrderDetails[0] !== "save") {
      toast.error(customerSaveOrderDetails[0])
    }
  }, [customerSaveOrderDetails])

  // function called to modify customer listing
	useEffect(() => {
		localStorage.setItem('Customer-Listing', 'on')
		handleExistingOrder()
	}, [])

  useMemo(() => {
    if(customerSaveOrderDetails.length > 0 && customerSaveOrderDetails[0] === "save" && customerSaveContractDetails.length > 0 && customerSaveContractDetails[0] === "saved") {
      resetState()
      localStorage.removeItem("copySelectedLaborList")
      localStorage.removeItem("selectedAllLaborMaterialCarpetData")
      localStorage.removeItem("selectedAllCarpetData")
      dispatch({ type: RESET_CUSTOMER_ORDER_DETAILS });

      navigate(`/existing-orders`)
    }
  }, [customerSaveOrderDetails, customerSaveContractDetails])

  // handle add on submit button
  const handleAddonButtonDisability = (isDisable) => {
    setIsAddOnSubmitted(isDisable)
  }

  //handle api response errors
  useEffect(() => {
    if(errors && errors?.data && (errors?.data?.title||errors?.data?.result)){
      toast.error(errors?.data?.title)
      handleAddonButtonDisability(false)
    if(errors?.data?.result?.length > 0 ){
        const msg = errors?.data?.result
        msg.map((m)=>{
          toast.error(m)
        })
      }}
  }, [errors])

  // handle labor and material listing
  const materialAndLaborListing = () => {
    fetchOrderInstallationMaterial(auth[0].token, jobNum)
    fetchOrderInstallationOrder(auth[0].token, jobNum)
  }

  // function to handle digits after decimal
  const formatNumberWithTwoDigitsAfterDecimal = (number) => {
    const numberString = parseFloat(number).toFixed(2); // Convert the number to a string with two decimal places
    const decimalIndex = numberString.indexOf('.');
    
    if (decimalIndex === -1) {
      // No decimal point found, so add two zeros after the number
      return numberString + '.00';
    }
  
    const digitsAfterDecimal = numberString.length - decimalIndex - 1;

    if (digitsAfterDecimal < 2) {
      // Add a zero after the number to make it two digits after the decimal point
      return numberString + '0';
    }
  
    // Return the number as is, already with two digits after the decimal point
    return numberString;
  }

  // function to generate key
  const generateKey = (item = {}) => [
    item.orderMaterialId ?? "",
    item.materialId ?? "",
    item.orderProductId ?? "",
    item.productId ?? "",
    item.orderLaborId ?? "",
    item.laborItemId ?? item.LaborItemId ?? "",
    item.laborId ?? item.LaborId ?? "",
    item.linePrice ?? item.LinePrice ?? "",
    item.quantity ?? item.Quantity ?? ""
  ].join("-")

  const loadLocalStorageDataSetup = () => {
    let data = JSON.parse(localStorage.getItem('selectedAllCarpetData') || '{}');
    if(data){
      console.log('--loadLocalStorageDataSetup--')
      setLocalStorageData(data)
    }
  }

  // function to upate material list data
  const updateMaterialList = (materialListData, localStorageData) => {
    let materialKeys = new Set(materialListData.map(generateKey))
    Object.values(localStorageData).flat().forEach(item => {
      if (!materialKeys.has(generateKey(item))) {
        let newEntry = Object.keys(item).reduce((acc, key) => {
          acc[key] = item[key];
          return acc
        }, {})
        materialListData.push(newEntry);
      }
    })
  }

  useEffect(() => {
    if (localStorageData && Object.keys(localStorageData).length > 0) {
      updateMaterialList(materialListData, localStorageData)
    }
  }, [localStorageData, lsUpdate])

  const [ localStorageLaborData, setLocalStorageLaborData ] = useState([])

  // handle transform of required array
  const handleTransformArray = (arr) => {
    if (arr && arr.length > 0) {
      let newKeys = ['laborItemId', 'laborId', 'quantity', 'gpm', 'linePrice', 'orderInstallationDetailId', 'createdBy', 'unitPrice', 'labor', 'unitName', 'laborCategory']
      return arr.map(obj =>
        Object.fromEntries(Object.values(obj).map((value, index) => [newKeys[index] || `key${index}`, value]))
      );
    } else {
      return []
    }
  }

  // handle duplicates for grid
  const removeOlderDuplicates = (data) => {
    const uniqueMap = new Map();

    data
      .slice()
      .reverse()
      .forEach((item) => {
        const uniqueKey = [
          item.orderMaterialId ?? "",
          item.materialId ?? "",
          item.orderProductId ?? "",
          item.productId ?? "",
          item.orderLaborId ?? "",
          item.laborItemId ?? "",
          item.laborId ?? "",
        ].join("-");

        if (!uniqueMap.has(uniqueKey)) {
          uniqueMap.set(uniqueKey, item);
        }
      });

    // Update data array in-place
    data.splice(0, data.length, ...[...uniqueMap.values()].reverse());
  };

  // handle updated listing for grid
  const handleUpdateQualityGrid = () => {
    let tempProductData = JSON.parse(localStorage.getItem('selectedAllLaborMaterialCarpetData'))
    let tempLaborData = JSON.parse(localStorage.getItem('copySelectedLaborList'))
    let modifiedTempLaborData = handleTransformArray(tempLaborData)
    orderInstallationListData.push(...(tempProductData?.labors ?? []), ...(modifiedTempLaborData ?? []))
    removeOlderDuplicates(orderInstallationListData)
  }

  const loadLocalStorageLaborDataSetup = () => {
    let data = JSON.parse(localStorage.getItem('copySelectedLaborList') || '{}');
    if(data){
      if (JSON.parse(localStorage.getItem('isQuality')) || !checkOrder) {
        handleUpdateQualityGrid()
      }
      setLocalStorageLaborData(data)
    }
  }

  const [ lsAllLaborMaterialCarpetData, setLsAllLaborMaterialCarpetData ] = useState({})

  // handle updated listing for grid
  const handleUpdateQualityListing = () => {
    let tempProductData = JSON.parse(localStorage.getItem('selectedAllLaborMaterialCarpetData'))
    let tempData = JSON.parse(localStorage.getItem('selectedAllCarpetData'))
    let flatTempData = tempData ? Object.values(tempData).flat() : []
    // if(flatTempData.length > 0){
    //   flatTempData = flatTempData.map(item => ({
    //     ...item,
    //     quantity: calculateLFQunatity(item),
    //     linePrice: calculateLFQunatity(item) * parseFloat(item['unitPrice'])
    //   }));
    // }
    materialListData.push(...flatTempData, ...(tempProductData?.materials ?? []))
    removeOlderDuplicates(materialListData)
  }

  const loadLocalStorageLaborMaterialCarpetData = () => {
    let data = JSON.parse(localStorage.getItem('selectedAllLaborMaterialCarpetData') || '{"materials":[],"labors":[]}');
    if(data){
      if (JSON.parse(localStorage.getItem('isQuality')) || !checkOrder) {
        handleUpdateQualityListing()
        handleUpdateQualityGrid()
      }
      setLsAllLaborMaterialCarpetData(data)
    }
  }

  // handle updated listing for grid
  const handleUpdateGrid = (orderInstallationData) => {
    let tempProductData = JSON.parse(localStorage.getItem('selectedAllLaborMaterialCarpetData'))
    let tempLaborData = JSON.parse(localStorage.getItem('copySelectedLaborList'))
    let modifiedTempLaborData = handleTransformArray(tempLaborData)
    orderInstallationData.push(...(tempProductData?.labors ?? []), ...(modifiedTempLaborData ?? []))
    removeOlderDuplicates(orderInstallationData)
  }

  // handle updated listing for grid
  const handleUpdateGridList = (tempOrderMaterial) => {
    let tempProductData = JSON.parse(localStorage.getItem('selectedAllLaborMaterialCarpetData'))
    let tempData = JSON.parse(localStorage.getItem('selectedAllCarpetData'))
    tempOrderMaterial.push(...(tempData ? Object.values(tempData).flat() : []), ...(tempProductData?.materials ?? []))
    removeOlderDuplicates(tempOrderMaterial)
  }

  // handle material listing api response
  useMemo(() => {
    if(orderMaterialData) {
      let tempOrderMaterial = orderMaterialData
      if (tempOrderMaterial.length  > 0 ) {
        tempOrderMaterial.map(data => {
          data.quantity = formatNumberWithTwoDigitsAfterDecimal(data.quantity)
          data.unitPrice = formatNumberWithTwoDigitsAfterDecimal(data.unitPrice)
          data.linePrice = formatNumberWithTwoDigitsAfterDecimal(data.linePrice)
        })
        tempOrderMaterial = Object.values(tempOrderMaterial)
      }
      if (!checkOrder) {
        handleUpdateGridList(tempOrderMaterial)
      }
      setMaterialListData(tempOrderMaterial)
    }
  }, [orderMaterialData])

  // handle order installation listing api response
  useMemo(() => {
    if(orderInstallationData) {
      let tempOrderInstallation = orderInstallationData
      if (tempOrderInstallation.length  > 0 ) {
        tempOrderInstallation.map(data => {
          data.quantity = formatNumberWithTwoDigitsAfterDecimal(data.quantity)
          data.unitPrice = formatNumberWithTwoDigitsAfterDecimal(data.unitPrice)
          data.linePrice = formatNumberWithTwoDigitsAfterDecimal(data.linePrice)
        })
        tempOrderInstallation = Object.values(tempOrderInstallation)
      }
      if (!checkOrder) {
        handleUpdateGrid(orderInstallationData)
      }
      setOrderInstallationListData(orderInstallationData)
    }
  }, [orderInstallationData])

  // auto-populate description after order material and labor data load, only if description is empty
  useEffect(() => {
    if (materialListData && materialListData.length > 0 && orderInstallationListData) {
      const savedDescription = customerOrderDetails?.[0]?.orderInstallationDetails?.Description || '';
      if (!savedDescription) {
        const autoDesc = computeAutoDescription(materialListData);
        if (autoDesc) {
          setState(prev => ({ ...prev, description: autoDesc }));
        }
      }
    }
  }, [materialListData, orderInstallationListData]);

  // clear storage data
  const clearStorageState = () => {
    localStorage.removeItem("selectedProductList")
    localStorage.removeItem("selectedLaborList")
    localStorage.removeItem("selectedMaterialList")
    localStorage.removeItem("selectedOrderLaborList")
  }

  //handle order save contract details data
  useEffect(() => {
    if(customerSaveContractDetails[0] === 'saved' && (materialContractModalOpen || laborContractModalOpen) && orderInstallationCarpetData) {
      setMaterialContractModalOpen(false)
      setLaborContractModalOpen(false)
      fetchOrderInstallationMaterial(auth[0].token, jobNum)
      fetchOrderInstallationOrder(auth[0].token, jobNum)
      setOrderInstallationCarpetData(false)
      clearStorageState()
    }
    if(customerSaveContractDetails[0] === 'not saved' && (materialContractModalOpen || laborContractModalOpen)) {
      toast.error(customerSaveContractDetails[0])
    }
  }, [customerSaveContractDetails])

  // handle delete material api response
  useEffect(() => {
    if(deletedOrderMaterialData[0] === 'deleted') {
      materialAndLaborListing()
      setConfirmDeleteModal(false)
    }
  }, [deletedOrderMaterialData])

  // handle delete labor api response
  useEffect(() => {
    if(deletedOrderLaborData[0] === 'deleted') {
      materialAndLaborListing()
      setConfirmDeleteModal(false)
    }
  }, [deletedOrderLaborData])

  // handle materialListData for listing
  useEffect(() => {
    if(materialListData && materialListData.length>0) {
      let totalUnitPrice = 0.00
      let totalLinePrice = 0.00
      let totalJobCost = 0.00
      materialListData.map(data => {
        totalUnitPrice += parseFloat(data.unitPrice) ? parseFloat(data.unitPrice) : parseFloat(data.price) ? parseFloat(data.price) : 0.00
        totalLinePrice += parseFloat(data.linePrice) ? parseFloat(data.linePrice) : 0.00
        if(data.lineCost){
          totalJobCost += parseFloat(data.lineCost) ? parseFloat(data.lineCost) : 0.00
        }
        else{
          totalJobCost += (data.linePrice * (100 - data.gpm)) / 100
        }
      })
      const totalProfit = totalLinePrice - totalJobCost
      const totalGPM = totalLinePrice ? (totalProfit / totalLinePrice) * 100 : 0.00
      setTotalMaterialUnitPrice(totalUnitPrice)
      setTotalMaterialLinePrice(totalLinePrice)
      setTotalMaterialJobCost(totalJobCost)
      setTotalMaterialProfit(totalProfit)
      setTotalMaterialGPM(totalGPM)
    } else {
      setTotalMaterialUnitPrice(0.00)
      setTotalMaterialLinePrice(0.00)
      setTotalMaterialJobCost(0.00)
      setTotalMaterialProfit(0.00)
      setTotalMaterialGPM(0.00)
    }
  }, [materialListData, materialContractModalOpen, pricingContractModalOpen])

  // handle laborListData for listing
  useEffect(() => {
    if(orderInstallationListData && orderInstallationListData.length>0) {
      let totalUnitPrice = 0.00
      let totalLinePrice = 0.00
      let totalOrgUnitPrice = 0.00
      let totalOrgLinePrice = 0.00
      let totalJobCost = 0.00
      orderInstallationListData.map(data => {
        totalUnitPrice += parseFloat(data.unitPrice) ? parseFloat(data.unitPrice) : parseFloat(data.price) ? parseFloat(data.price) : 0.00
        totalLinePrice += parseFloat(data.linePrice) ? parseFloat(data.linePrice) : 0.00

        totalOrgUnitPrice += parseFloat(data.unitCost) ? parseFloat(data.unitCost) : 0.00
        totalOrgLinePrice += parseFloat(data.lineCost) ? parseFloat(data.lineCost) : 0.00
        if(data.lineCost){
          totalJobCost += parseFloat(data.lineCost) ? parseFloat(data.lineCost) : 0.00
        }
        else{
          totalJobCost += (data.linePrice * (100 - data.gpm)) / 100
        }
      })
      const totalProfit = totalLinePrice - totalJobCost
      const totalGPM = totalLinePrice ? (totalProfit / totalLinePrice) * 100 : 0.00
      setTotalLaborUnitPrice(totalUnitPrice)
      setTotalLaborLinePrice(totalLinePrice)
      setTotalLaborOrgUnitPrice(totalOrgUnitPrice)
      setTotalLaborOrgLinePrice(totalOrgLinePrice)
      setTotalLaborJobCost(totalJobCost)
      setTotalLaborProfit(totalProfit)
      setTotalLaborGPM(totalGPM)
    } else {
      setTotalLaborUnitPrice(0.00)
      setTotalLaborLinePrice(0.00)
      setTotalLaborOrgUnitPrice(0.00)
      setTotalLaborOrgLinePrice(0.00)
      setTotalLaborJobCost(0.00)
      setTotalLaborProfit(0.00)
      setTotalLaborGPM(0.00)
    }
  }, [orderInstallationListData, laborContractModalOpen, pricingContractModalOpen])

  // function to handle order total
  useMemo(() => {
    if(totalLaborLinePrice !== '' && totalMaterialLinePrice !== '') {
      let orderTotal = parseFloat(totalLaborLinePrice ? totalLaborLinePrice : 0.00) + parseFloat(totalMaterialLinePrice ? totalMaterialLinePrice : 0)
      setOrderTotal(orderTotal)
    }
  }, [totalLaborLinePrice, totalMaterialLinePrice])

  // build color-coded key entries from material and labor lists for floorplan legend
  const colorKeyItems = useMemo(() => {
    const items = [];
    const seen = new Set();
    const addItem = (name, color) => {
      if (color && name) {
        const key = `${name}-${color}`;
        if (!seen.has(key)) {
          seen.add(key);
          items.push({ name, color });
        }
      }
    };
    if (materialListData) {
      materialListData.forEach(data => {
        if(data.customColor !== 'N/A' &&  data.customColor !== ''){
          const name = data.privateName || data.pvtName || data.product || data.style || '';
          addItem(name, data.customColor);
        }
      });
    }
    if (orderInstallationListData) {
      orderInstallationListData.forEach(data => {
        if(data.customColor !== 'N/A' &&  data.customColor !== ''){
          const name = data.labor || data.laborName || '';
          addItem(name, data.customColor);
        }
      });
    }
    return items;
  }, [materialListData, orderInstallationListData])

  // function to handle saved add on data
  useEffect(() => {
    if (saveOrderAddOnDetails && saveOrderAddOnDetails.length > 0) {
      if (changeJobHeader === 'Add On' && saveOrderAddOnDetails[0] === 'AddOn Details Saved Successfully') {
        toast.success(saveOrderAddOnDetails[0])
        let tmpIsDeleted = isOrderDeleted()
        fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
        fetchOrderInstallationMaterial(auth[0].token, jobNum)
        fetchOrderInstallationOrder(auth[0].token, jobNum)
        handleMakeChangeClose()
        handleAddonButtonDisability(false)
      } else if (changeJobHeader === 'Add On' && saveOrderAddOnDetails[0]) {
        toast.error(saveOrderAddOnDetails[0])
        setIsAddOnSubmitted(false)
      }
    }
  }, [saveOrderAddOnDetails])

  const handleUpdateCustomerDetail = () => {
		fetchCustomerList(auth[0].token, "asc", 1, 1, { 'contactInfoId': id }, auth[0].userId, false, false, false);
	}

  // function called on input change event
	const handleChange = (e) => {
		const { id, value } = e.target
		setState({
      ...state,
      [id]: value
    })
    // Commented on 03-07-2024 for add on implementation
    // if (id === "newUnitId") {
    //   let payload = {
    //     UnitName: e.target.value,
    //     ContactInfoId: parseInt(contactInfoId),
    //     UnitId: parseInt(unitId)
    //   }
    //   saveCustomerOrderUnitId(auth[0].token, payload)
    // }
    // if (id === "newUnitTypeId") {
    //   let payload = {
    //     UnitTypeName: e.target.value,
    //     ContactInfoId: parseInt(contactInfoId),
    //     UnitTypeId: parseInt(customerOrderData[0].UnitTypeId) ? parseInt(customerOrderData[0].UnitTypeId) : 0
    //   }
    //   saveCustomerOrderUnitTypeId(auth[0].token, payload)
    // }
	}

  // function to handle reschedule job change
  const handleRescheduleChange = (e) => {
    const { id, value } = e.target
    setRescheduleData(
			{
				...rescheduleData,
				[id]: value
			}
		)
  }

  // function to open pricing contract modal
	const showPricingContractModal = () => {
    clearStorageState()
		setPricingContractModalOpen(true)
    setMaterialContractModalOpen(true)
	}

  // function to remove matching items
  const removeMatchingItems = (list, removedData) => {
    const removedKeys = new Set(removedData.laborData.map(item => generateKey(item)))
    list.forEach((item, index) => {
      if (removedKeys.has(generateKey(item))) {
        list.splice(index, 1)
      }
    })
  }

  const removeMatchingItem = (list, itemToRemove) => {
    const itemKey = generateKey(itemToRemove)
    list.forEach((item, index) => {
      if (generateKey(item) === itemKey) {
        list.splice(index, 1)
      }
    })
  }

	// function to close pricing contract modal
	const hidePricingContractModal = () => {
    clearStorageState()
		setPricingContractModalOpen(false)
    setMaterialContractModalOpen(false)
    setLaborContractModalOpen(false)
    if(localStorage.getItem("selectedAllCarpetData")){
      setLsUpdate(true)
      loadLocalStorageDataSetup()
    }
    if(localStorage.getItem("copySelectedLaborList")){
      setLsLaborUpdate(true)
      loadLocalStorageLaborDataSetup()
    }
    if(localStorage.getItem("selectedAllLaborMaterialCarpetData")){
      setLsLaborMaterialUpdate(true)

      loadLocalStorageLaborMaterialCarpetData()
    }
    if (orderInstallationListData && orderInstallationListData.length > 0 && JSON.parse(localStorage.getItem('isQuality'))) {
      let removedData = JSON.parse(localStorage.getItem('removedQualityPCData'))
      if (deleteOrderData) {
        removeMatchingItem(orderInstallationListData, deleteOrderData)
      }
      if (removedData) {
        removeMatchingItems(orderInstallationListData, removedData)
      }
    }
	}

  // function to add new material
  const handleClickNewMaterialItem = () => {
    clearStorageState()
    localStorage.setItem("addOnModal",JSON.stringify({"addOnModalOpen":true,"addNewMaterialItemClicked":true,"addNewLaborItem":false}))
    setPricingContractModalOpen(true)
    setMaterialContractModalOpen(true)
  }

  // function to add new labor
  const handleClickNewLabourItem = () => {
    changeReducerState()
    localStorage.setItem("addOnModal",JSON.stringify({"addOnModalOpen":true,"addNewMaterialItemClicked":false,"addNewLaborItem":true}))
    clearStorageState()
    setLaborContractModalOpen(true)
    setPricingContractModalOpen(true)
  }

  // handle edit change on material listing
  const handleMaterialListingEditChange = (value, data, filterValue) => {
    if(materialListData && materialListData.length > 0) {
      let materialData = materialListData
      materialData.map(editedData => {
        if((data.orderMaterialId || data.orderProductId) ? (data.orderMaterialId === editedData.orderMaterialId && data.orderProductId === editedData.orderProductId) : (data.materialId === editedData.materialId && data.productId === editedData.productId)) {
          if(filterValue === 'quantity') {
            editedData.quantity = value
            editedData.linePrice = parseFloat(parseFloat(value) * parseFloat(editedData.unitPrice ? editedData.unitPrice : editedData.price)).toFixed(2)
          }
          if(filterValue === 'unitPrice') {
            editedData.unitPrice = value
            editedData.linePrice = parseFloat(parseFloat(value) * parseFloat(editedData.quantity)).toFixed(2)
          }
          if(filterValue === 'linePrice') {
            editedData.linePrice = value
            editedData.quantity = parseFloat(parseFloat(value) / parseFloat(editedData.unitPrice ? editedData.unitPrice : editedData.price)).toFixed(2)
          }
        }
      })
      materialData = Object.values(materialData)
			setMaterialListData(materialData)
    }
  }
  
  const updateQualityData = () => {
    if(JSON.parse(localStorage.getItem("Existing-Orders-Page")) === true){
      let tempSelectedCarpetData = JSON.parse(localStorage.getItem("selectedAllCarpetData")) || {}
      const updatedOrgList = Object.keys(tempSelectedCarpetData).reduce((acc, key) => {
      acc[key] = localStorageData[key].map(orgItem => {
        // find matching item in newList by productId
        const match = materialListData.find(
          newItem => newItem.productId === orgItem.productId
        );

        // if match found → merge/update fields from newList
        if (match) {
          return {
            ...orgItem,
            ...match   // update values from newList (like quantity, price, gpm, etc.)
          };
        }

        return orgItem; // no match → keep original
      });

      return acc;
    }, {});
    localStorage.setItem("selectedAllCarpetData", JSON.stringify(updatedOrgList));
    }
  }

  // function call on modifying material kit listing
	const handleMaterialItemChange = (e, data, filterValue) => {
		handleMaterialListingEditChange(e.target.value, data, filterValue)
    const productStructureId = parseInt(data.productStructureId, 10);
    updateQualityData(productStructureId, e.target.value)
	}

  const handleMaterialQuantityBlur = (e, data) => {

    if (!data) {
      return;
    }
    
    const productStructureId = parseInt(data.productStructureId, 10);
    const enteredQuantity = parseFloat(e.target.value);
    if (isNaN(enteredQuantity)) {
      return;
    }
    if (productStructureId === CARPET_ID_DB || productStructureId === SHEET_VINYL_ID_DB) {
      let rollWidth = data?.width || 0;
      let formattedQuantity = applySnapToGridForRolledGoods(enteredQuantity, rollWidth)
      handleMaterialListingEditChange(formattedQuantity, data, "quantity");
      updateQualityData(productStructureId, formattedQuantity)
    }
    if (productStructureId === WALLBASE_ID_DB) {
      const coverageValue = parseFloat(
        data?.coverage ?? data?.Coverage ?? data?.productCoverage ?? 0
      );
      if (!coverageValue || !isFinite(coverageValue)) {
        return;
      }
      let recalculatedQuantity = Number(enteredQuantity);
      if(data?.unit === 'LF' || data?.unitName === 'LF'){
        recalculatedQuantity =
          Math.ceil(enteredQuantity / coverageValue) * coverageValue;
        if (!isFinite(recalculatedQuantity)) {
          return;
        }
      }
      else if(data?.unit === 'EA' || data?.unitName === 'EA'){
        recalculatedQuantity = Math.ceil(Number(enteredQuantity).toFixed(2));
      }
      const formattedQuantity = Number(recalculatedQuantity).toFixed(2);

      // if (parseFloat(data.quantity) === formattedQuantity) {
      //   return;
      // }
      handleMaterialListingEditChange(formattedQuantity, data, "quantity");
      updateQualityData(productStructureId, formattedQuantity)
    } else if (productStructureId === TRANSITION_ID_DB) {
      const roundedQuantity = Math.ceil(enteredQuantity);

      handleMaterialListingEditChange(roundedQuantity, data, "quantity");
      updateQualityData(productStructureId, formattedQuantity)
    }
  };

  // handle edit change on labor listing
  const handleLaborListingEditChange = (value, data, filterValue) => {
    if(orderInstallationListData && orderInstallationListData.length > 0) {
      let laborData = orderInstallationListData
      laborData.map(editedData => {
        if(data.orderLaborId ? data.orderLaborId === editedData.orderLaborId : (data.laborItemId === editedData.laborItemId && data.laborId === editedData.laborId)) {
          if(filterValue === 'quantity') {
            editedData.quantity = value
            editedData.linePrice = parseFloat(parseFloat(value) * parseFloat(editedData.unitPrice ? editedData.unitPrice : editedData.price)).toFixed(2)
          }
          if(filterValue === 'unitPrice') {
            editedData.unitPrice = value
            editedData.linePrice = parseFloat(parseFloat(value) * parseFloat(editedData.quantity)).toFixed(2)
          }
          if(filterValue === 'linePrice') {
            editedData.linePrice = value
            if (editedData.labor?.toLowerCase() || data.laborName?.toLowerCase() === 'odor b gone application') {
              editedData.quantity = 1.00
            } else {
              editedData.quantity = parseFloat(parseFloat(value) / parseFloat(editedData.unitPrice ? editedData.unitPrice : editedData.price)).toFixed(2)
            }
          }
        }
      })
      laborData = Object.values(laborData)
			setOrderInstallationListData(laborData)
    }
  }

  // function call on modifying labor listing
	const handleLaborItemChange = (e, data, filterValue) => {
		handleLaborListingEditChange(e.target.value, data, filterValue)
	}
  
  const hidePdfElem = (inputElem, cName, colIndex, showType) => {
    let table = inputElem.querySelector(`.${cName}`);

    if (table) {
      let thead = table.querySelector("thead tr");
      let tbodyRows = table.querySelectorAll("tbody tr:not(:last-child)"); // Exclude last row

      let colIndexes = colIndex; // 1st, 2nd, and 6th columns (0-based index)

      // Hide columns in thead
      colIndexes.forEach(index => {
          if (thead) {
              let th = thead.children[index];
              if (th) th.style.display = showType;
              if(showType ==='block'){
                if (th) th.removeAttribute("style")
              }
          }
      });

      // Hide columns in tbody (excluding last row)
      tbodyRows.forEach(row => {
          colIndexes.forEach(index => {
              let td = row.children[index];
              if (td) td.style.display = showType;
              if(showType ==='block'){
                if (td) td.removeAttribute("style")
              }
          });
      });
      // Select the second <td> (index 1) in the last row of <tbody> and clear its text
      let lastRow = inputElem.querySelector(`.${cName} tbody tr:last-child`);
      if (lastRow) {
          let secondTd = lastRow.children[1]; // 1-based index
          if (secondTd) {
              secondTd.querySelector("div").style.display = showType;
              if(showType ==='block'){
                secondTd.querySelector("div").removeAttribute("style")
              }
          }
          let fourthTd = lastRow.children[3]; // 1-based index
          if (fourthTd) {
              fourthTd.style.display = showType;
              if(showType ==='block'){
                fourthTd.removeAttribute("style")
              }
          }
      }

      // Select the <td> with colspan="5" and change it to colspan="2"
      let tmpColSpan = (cName === 'order-material-pdf') ? 5 : 4
      let tmpChangeSpan = (cName === 'order-material-pdf') ? 2 : 1
      if(showType === 'block'){
        tmpColSpan = (cName === 'order-material-pdf') ? 2 : 1
        tmpChangeSpan = (cName === 'order-material-pdf') ? 5 : 4
      }
      let colspanTd = inputElem.querySelector(`.${cName} tbody tr td[colspan='${tmpColSpan}']`);
      if (colspanTd) {
          colspanTd.setAttribute("colspan", tmpChangeSpan);
      }
    }
  }
  const handleSaveClick = () => {
    dispatch({ type: RESET_CUSTOMER_ORDER_DETAILS });
    let pdfFile={}; let payload={}; let clientPdfFile={};
    const generatePDF =  () => {
      const pdfInput = document.getElementById("pdfcontainer")
      // const storeLogo = document.getElementById("store-pdf-logo")
      // Copy the container's HTML content
      const input = pdfInput.cloneNode(true); 
      const submitButton = input.querySelector("#submitpdf");
      const cancelButton = input.querySelector("#pdcancel");
      const materialbutton = input.querySelector("#pdfmaterialitem");
      const laborbutton = input.querySelector("#pdflaboritem");
      const materialitemaction=input.querySelector("#pdfactionmaterial")
      const laboritemaction=input.querySelector("#pdfactionlabor")
      const planElem = input.querySelector(".plan-img-container");
      if (planElem) {
          planElem.classList.replace("col-md-5", "col-md-10");
      }
      // remove scroll 
      input.querySelectorAll(".fixTableHead").forEach(element => element.classList.remove("fixTableHead"));

      if (input.querySelector("#store-pdf-logo")) {
          input.querySelector("#store-pdf-logo").style.display = "block"; // Change display to block
          input.querySelector(".store_phone").style.display = "block";
      }
      if (submitButton) submitButton.style.display = "none";
      // if (storeLogo) storeLogo.style.display = "block";
      if (cancelButton) cancelButton.style.display = "none";
      if (materialbutton) materialbutton.style.display = "none";
      if (laborbutton) laborbutton.style.display = "none";
      if (materialitemaction) materialitemaction.style.display = "none";
      if (laboritemaction) laboritemaction.style.display = "none";
      const buttons = input.querySelectorAll("button");
      buttons.forEach((button) => {
        button.style.display = "none";
      });
      const options = {
        margin: 0.2,
        filename: 'OrderDetails.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          scrollY: 0,
          scrollX:0
        },
        pagebreak: { before: '.pageBreak', mode: ['avoid-all', 'css', 'legacy'], avoid: 'svg' },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      };
      setTimeout( async () => {
        
        const clientPdfInput = input.cloneNode(true); 
        if (clientPdfInput) {
          // remove scroll 
          clientPdfInput.querySelectorAll(".fixTableHead").forEach(element => element.classList.remove("fixTableHead"));
          // hide only for client pdf
          hidePdfElem(clientPdfInput, 'order-material-pdf', [0,1,5,7], 'none');
          hidePdfElem(clientPdfInput, 'order-labor-pdf', [0,1,4,6], 'none');
          if (clientPdfInput.querySelector("#store-pdf-logo")) {
              clientPdfInput.querySelector("#store-pdf-logo").style.display = "block"; // Change display to block
              clientPdfInput.querySelector(".store_phone").style.display = "block";
          }
          let optionalElems = clientPdfInput.querySelectorAll(".pdf-optional");
          optionalElems.forEach(elem => elem.style.display = "none");
        }
        // hinde from client pdf
        clientPdfInput.querySelectorAll(".only-for-admin").forEach(elem => elem.style.display = "none");
        // hide from admin pdf
        input.querySelectorAll(".only-for-admin").forEach(elem => elem.style.display = "none");
        const pdfBlob = await html2pdf().from(input).set(options).output('blob');
        pdfFile = new File([pdfBlob], 'Orderdetails.pdf', { type: 'application/pdf' });
        const clientPdfBlob = await html2pdf().from(clientPdfInput).set(options).output('blob');
        clientPdfFile = new File([clientPdfBlob], 'ClientOrderPDF.pdf', { type: 'application/pdf' });
        // const blobURL = URL.createObjectURL(clientPdfBlob);
        // window.open(blobURL);
        payload= {
          OrderPDF: pdfFile,
          ClientPDF: clientPdfFile,
          InstallationData: JSON.stringify({
           UnitName: state.newUnitId,
          UnitType: state.newUnitTypeId,
          Notes: state.internalNotes ? state.internalNotes : "",
          InstallationInstracution: state.installerInstructions
            ? state.installerInstructions
            : "",
          ContactInfoId: parseInt(contactInfoId),
          OrderInstallationDetailId:
          customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
          Description: state.description ? state.description : "",
          PurchaseOrder: state.PurchaseOrder ? state.PurchaseOrder : "",
          OldUnitId: parseInt(unitId),
          OldUnitType: parseInt(customerOrderData[0].UnitTypeId)
            ? parseInt(customerOrderData[0].UnitTypeId)
            : 0,
          })
        }; 
        saveCustomerOrderDetails(auth[0].token, payload);
      }, 1000); 
    };
    generatePDF();
  };

  const handleUpdateOrderClick = () => {
    if(customerOrderData[0]?.orderInstallationDetails?.PurchaseOrder !== state.PurchaseOrder){
      let payload = {
        'PurchaseOrder': state.PurchaseOrder,
        'OrderInstallationDetailId': customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
        'JobNo': jobNum
      };
      console.log('--handleUpdateOrderClick payload--')
      // setOrderDetailUpdateMessage('Purchase order number updated!')
      updateOrderDetail(auth[0].token, payload);
      setCustomerOrderData(prev => [{
        ...prev[0],
        orderInstallationDetails: {
          ...prev[0]?.orderInstallationDetails,
          PurchaseOrder: state.PurchaseOrder
        }
      }]);
    }
  }

  const handleSaveOrderDetailFields = (orderInstallationDetailsOverride = null) => {
    if ((!orderInstallationDetailsOverride && (!customerOrderData || customerOrderData.length === 0))) {
      toast.error('Unable to update order details. Please try again.');
      return;
    }

    const targetOrder = orderInstallationDetailsOverride
      ? customerOrderData?.find(order => order?.orderInstallationDetails?.OrderInstallationDetailId === orderInstallationDetailsOverride?.OrderInstallationDetailId)
      : customerOrderData?.find(order => order?.orderInstallationDetails?.OrderInstallationDetailId);

    const orderInstallationDetails = orderInstallationDetailsOverride || targetOrder?.orderInstallationDetails;

    if (!orderInstallationDetails?.OrderInstallationDetailId) {
      toast.error('Unable to update order details. Please try again.');
      return;
    }

    const payload = {
      Description: state.description || '',
      InternalNotes: state.internalNotes || '',
      InstallerInstruction: state.installerInstructions || '',
      OrderInstallationDetailId: orderInstallationDetails.OrderInstallationDetailId,
      JobNo: jobNum
    };

    const existingDescription = orderInstallationDetails?.Description || '';
    const existingInternalNotes = orderInstallationDetails?.InternalNotes || '';
    const existingInstallerInstruction =
      orderInstallationDetails?.InstallerInstruction ||
      orderInstallationDetails?.Instruction ||
      '';

    const hasChanges = existingDescription !== payload.Description ||
      existingInternalNotes !== payload.InternalNotes ||
      existingInstallerInstruction !== payload.InstallerInstruction;

    if (!hasChanges) {
      toast.info('No changes to save.');
      return;
    }

    // setOrderDetailUpdateMessage('Order details updated!');
    updateOrderDetail(auth[0].token, payload);
    setCustomerOrderData(prev => {
      if (!prev || prev.length === 0) {
        return prev;
      }

      return prev.map(order => {
        if (order?.orderInstallationDetails?.OrderInstallationDetailId !== orderInstallationDetails.OrderInstallationDetailId) {
          return order;
        }

        return {
          ...order,
          orderInstallationDetails: {
            ...order.orderInstallationDetails,
            Description: payload.Description,
            InternalNotes: payload.InternalNotes,
            InstallerInstruction: payload.InstallerInstruction,
            Instruction: payload.InstallerInstruction
          }
        };
      });
    });
  }

  // handle fetching of data using key
  const fetchValue = () => {
    let data = JSON.parse(localStorage.getItem('SaveQualityOrderReason'))
    const key = "OrderQualityDetailId"
    const item = data.find((item) => item.startsWith(`${key} :`));
    if (item) {
      const value = item.split(":")[1]?.trim();
      return parseInt(value) || null;
    }
    return null;
  };

  const handleQualitySaveClick = () => {

    let productList = []
    let materialList = []
    let laborList = []
    materialListData.map(data => {
      if(data.orderProductId) {
        productList.push({
          ProductId: data.productId,
          Quantity: parseFloat(data.quantity),
          GPM: parseFloat(data.gpm),
          LinePrice: parseFloat(data.linePrice),
          OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
          CreatedBy: parseFloat(auth[0].userId),
          UnitPrice: parseFloat(data.unitPrice),
        })
      }
      if(data.orderMaterialId) {
        materialList.push({
          MaterialId: parseFloat(data.materialId),
          Product: parseFloat(data.productId),
          Quantity: parseFloat(data.quantity),
          GPM: parseFloat(data.gpm),
          LinePrice: parseFloat(data.linePrice),
          OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
          CreatedBy: parseFloat(auth[0].userId),
          UnitPrice: parseFloat(data.unitPrice),
        })
      }
    })
    if(orderInstallationListData && orderInstallationListData.length>0) {
      orderInstallationListData.map(data => {
        laborList.push({
          LaborItemId: data.laborItemId,
          LaborId: data.laborId,
          Quantity: data.quantity,
          GPM: data.gpm,
          LinePrice: data.linePrice,
          OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
          CreatedBy: parseFloat(auth[0].userId),
          UnitPrice: data.unitPrice,
        })
      })
    }
    let measureImagePng = customerOrderData[0]?.orderInstallationDetails?.MeasureImagePng;
    let quality_order_img = sessionStorage.getItem('quality-order-img');
    if(quality_order_img){
      measureImagePng = quality_order_img;
    }
    let getSelectedCarpetData = JSON.parse(localStorage.getItem("selectedAllCarpetData")) || {}
    let getSelectedLaborMaterialData = JSON.parse(localStorage.getItem("selectedAllLaborMaterialCarpetData")) || {}
    let combinedArray = Object.values(getSelectedCarpetData).flat()
    let materialsArray = getSelectedLaborMaterialData?.materials ?? [];
    combinedArray.forEach(data => {
      if (!productList.some(p => p.ProductId === data.productId)) {
        productList.push({
          ProductId: data.productId,
          Quantity: parseFloat(data.quantity),
          GPM: parseFloat(data.gpm ?? 0),
          LinePrice: parseFloat(data.linePrice),
          OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
          CreatedBy: parseFloat(auth[0].userId),
          UnitPrice: parseFloat(data.unitPrice)
        });
      }
    });
    materialsArray.forEach(data => {
      if (!materialList.some(m => m.MaterialId === parseFloat(data.materialId))) {
        materialList.push({
          MaterialId: parseFloat(data.materialId),
          Product: parseFloat(data.productId),
          Quantity: parseFloat(data.quantity),
          GPM: parseFloat(data.gpm ?? 0),
          LinePrice: parseFloat(data.linePrice),
          OrderInstallationDetailId: customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId,
          CreatedBy: parseFloat(auth[0].userId),
          UnitPrice: parseFloat(data.unitPrice)
        });
      }
    });
    let orderVariant = localStorage.getItem('order-VariantId') ?? 0;
    if(orderVariant === 'undefind'){
      orderVariant = 0;
    }
    const payload = {
      "jobNo": parseInt(JSON.parse(localStorage.getItem('quality-JobNum'))),
      "orderInstallationDetail": {
          "InstallationDate": customerOrderData[0]?.orderInstallationDetails?.InstallationDate ? customerOrderData[0]?.orderInstallationDetails?.InstallationDate : "",
          "Occupaied": customerOrderData[0]?.orderInstallationDetails?.Occupaied ? customerOrderData[0]?.orderInstallationDetails?.Occupaied : false,
          "PurchaseOrder": customerOrderData[0]?.orderInstallationDetails?.PurchaseOrder ? customerOrderData[0]?.orderInstallationDetails?.PurchaseOrder : "",
          "Instruction": customerOrderData[0]?.orderInstallationDetails?.Instruction ? customerOrderData[0]?.orderInstallationDetails?.Instruction : "",
          "FullName": customerOrderData[0]?.orderInstallationDetails?.FullName ? customerOrderData[0]?.orderInstallationDetails?.FullName: "",
          "Email": customerOrderData[0]?.orderInstallationDetails?.Email ? customerOrderData[0]?.orderInstallationDetails?.Email : "",
          "PhoneNo": customerOrderData[0]?.orderInstallationDetails?.PhoneNo ? customerOrderData[0]?.orderInstallationDetails?.PhoneNo : "",
          "ContactInfoId": customerOrderData[0]?.orderInstallationDetails?.ContactInfoId ? customerOrderData[0]?.orderInstallationDetails?.ContactInfoId : "",
          "CreatedBy": customerOrderData[0]?.orderInstallationDetails?.CreatedBy ? parseFloat(customerOrderData[0]?.orderInstallationDetails?.CreatedBy) : "",
          "ProductStructureId": customerOrderData[0]?.orderInstallationDetails?.ProductStructureId ? customerOrderData[0]?.orderInstallationDetails?.ProductStructureId : "",
          "UnitId":  customerOrderData[0]?.orderInstallationDetails?.UnitId ? customerOrderData[0]?.orderInstallationDetails?.UnitId : "",
          "UnitTypeId": customerOrderData[0]?.orderInstallationDetails?.UnitTypeId ? customerOrderData[0]?.orderInstallationDetails?.UnitTypeId : "",
          "InternalNotes": state.internalNotes ? state?.internalNotes : "",
          "InstallerInstruction": state?.installerInstructions ? state?.installerInstructions : "",
          "orderQualityDetailId": JSON.parse(localStorage.getItem('SaveQualityOrderReason')) ? fetchValue() : null,
          "Description": state.description ? state.description : "",
          "uniqueChannelName": JSON.parse(localStorage.getItem('geoErp'))[0]?.uniqueChannelName,
          "MeasureImagePng": measureImagePng,
          "UnitName": state?.newUnitId ? state?.newUnitId : "",
          "UnitTypeName": state?.newUnitTypeId ? state?.newUnitTypeId : "",
          "TotalTax": state?.TotalTax ? state?.TotalTax : "",
          "VariantId": parseInt(orderVariant)

      },
      "orderQualityProduct": productList,
      "orderQualityMaterial": materialList,
      "orderQualityLabor": laborList,
    }
    console.log('--saveQualityOrderDetail payload--')
    setMaterialListData();
    // return true;
    saveQualityOrderDetail(auth[0].token, payload)

    localStorage.setItem("Qualityorder",0)
    sessionStorage.removeItem('quality-order-img');
    localStorage.removeItem('quality-order');
   }

  const normalizeBase64Image = (value) => {
    if (!value) return "";
    const trimmedValue = value.trim();
    if (trimmedValue.startsWith('data:image')) {
      return trimmedValue;
    }
    if (trimmedValue.startsWith('http://') || trimmedValue.startsWith('https://')) {
      return trimmedValue;
    }
    return `data:image/png;base64,${trimmedValue}`;
  }

  const getMeasureImagePng = () => {
    const measureImagePng = customerOrderData?.[0]?.orderInstallationDetails?.MeasureImagePng;
    const qualityOrderLocal = sessionStorage.getItem('quality-order-img');
    const qualityOrder = qualityOrderData || {};

    return normalizeBase64Image(
      qualityOrderLocal ||
      qualityOrder?.PngImage ||
      qualityOrder?.FloorPlan ||
      measureImagePng ||
      ""
    );
   } 

  //function to save contract for order details
  const saveContractForOrderDetails = (data, bool) => {
    setOrderInstallationCarpetData(bool)
    saveCustomerOrderDetailsForPricingContract(auth[0].token, data)
  }

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeleteOrderData('')
    setConfirmDeleteModal(false)
  }

  // remove from secondary product data
  const removeEntries = (dataObject, removedItems, label) => {
    Object.keys(dataObject).forEach(key => {
      if (!Array.isArray(dataObject[key])) return
      const removedKeys = new Set(removedItems.map(generateKey))
      dataObject[key] = dataObject[key].filter(item => !removedKeys.has(generateKey(item)))
    });
  };

  // Remove from product data
  const removeFromSelectedCarpetData = (selectedData, removedItems, productToRemove) => {
    const productIdToRemove = deleteOrderData.productId;

    Object.keys(selectedData).forEach(key => {
      selectedData[key] = selectedData[key].filter(item => item.productId !== productIdToRemove);

      if (selectedData[key].length === 0) {
        delete selectedData[key];
      }
    })
  }

  // function to filter list
  const filterSelectedLaborList = (tempCopySelectedLaborList, removedItems) => {
    if (!Array.isArray(tempCopySelectedLaborList)) {
      return tempCopySelectedLaborList;
    }
    const removedKeys = new Set(removedItems.map(generateKey));
    return tempCopySelectedLaborList.filter(item => !removedKeys.has(generateKey(item)));
  }

  // Remove from labor data
  const removeLaborData = (tempCopySelectedLaborList, removedItems) => {
    const updatedList = filterSelectedLaborList(tempCopySelectedLaborList, removedItems);
    return updatedList
  }

  // function to update listing on grid updation
  const handleUpdateGridData = (removedItems) => {
    let tempSelectedCarpetData = JSON.parse(localStorage.getItem("selectedAllCarpetData")) || {}
    let tempAllLaborMaterialCarpetData = JSON.parse(localStorage.getItem("selectedAllLaborMaterialCarpetData")) || {}
    let tempCopySelectedLaborList = JSON.parse(localStorage.getItem("copySelectedLaborList")) || {}
    // Call function to remove matching entries
    removeFromSelectedCarpetData(tempSelectedCarpetData, removedItems, "tempSelectedCarpetData");
    removeEntries(tempAllLaborMaterialCarpetData, removedItems, "tempAllLaborMaterialCarpetData");
    tempCopySelectedLaborList = removeLaborData(tempCopySelectedLaborList, removedItems);

    localStorage.setItem("selectedAllCarpetData", JSON.stringify(tempSelectedCarpetData));
    localStorage.setItem("selectedAllLaborMaterialCarpetData", JSON.stringify(tempAllLaborMaterialCarpetData));
    localStorage.setItem("copySelectedLaborList", JSON.stringify(tempCopySelectedLaborList));
  }

  // function to delete data
  const removeDeletedEntry = (productData = {}, laborData = [], deleteOrderData = {}) => {

    const uniqueKey = generateKey(deleteOrderData)

    const storedRemovedData = localStorage.getItem('removedQualityPCData');
    let removedEntries = storedRemovedData ? JSON.parse(storedRemovedData) : { labors: [], materials: [], laborData: [] };

    const removeMatchingEntriesInPlace = (arr, label) => {
      if (!Array.isArray(arr)) return arr

      const { filteredArray, removedItems } = arr.reduce(
        (acc, item) => {
          const itemKey = generateKey(item)
          if (itemKey === uniqueKey) {
            acc.removedItems.push(item)
          } else {
            acc.filteredArray.push(item)
          }
          return acc
        },
        { filteredArray: [], removedItems: [] }
      )


      removedEntries[label] = [...removedEntries[label], ...removedItems]
      localStorage.setItem('removedQualityPCData', JSON.stringify(removedEntries))
      handleUpdateGridData(removedItems)
      return filteredArray
    }

    if (productData.labors) productData.labors = removeMatchingEntriesInPlace(productData.labors, "labors")
    if (productData.materials) productData.materials = removeMatchingEntriesInPlace(productData.materials, "materials")
    if (Array.isArray(laborData)) laborData = removeMatchingEntriesInPlace(laborData, "laborData")

  }

  // function to remove order data
  const removeDeletedOrderData = () => {
    let tempProductData = JSON.parse(localStorage.getItem('selectedAllLaborMaterialCarpetData')) || []
    let tempLaborData = JSON.parse(localStorage.getItem('copySelectedLaborList')) || []
    removeDeletedEntry(tempProductData, tempLaborData, deleteOrderData)
    localStorage.setItem('selectedAllLaborMaterialCarpetData', JSON.stringify(tempProductData))
    localStorage.setItem('copySelectedLaborList', JSON.stringify(tempLaborData))
    let tempCopySelectedLaborList = JSON.parse(localStorage.getItem("copySelectedLaborList")) || {}
    tempCopySelectedLaborList = removeLaborData(tempCopySelectedLaborList, [deleteOrderData])
    localStorage.setItem("copySelectedLaborList", JSON.stringify(tempCopySelectedLaborList))
  }

  // handle grid data removal
  const removeGridData = () => {
    if(deleteOrderData.orderMaterialId || deleteOrderData.materialId) {
      setMaterialListData(prev => prev.filter(item => item.orderMaterialId !== deleteOrderData.orderMaterialId || item.materialId !== deleteOrderData.materialId))
    } else if(deleteOrderData.orderProductId || deleteOrderData.productId && !deleteOrderData.orderLaborId) {
      setMaterialListData(prev => prev.filter(item => item.orderProductId !== deleteOrderData.orderProductId || item.productId !== deleteOrderData.productId))
    } else {
      setOrderInstallationListData(prev => prev.filter(item =>!(item.laborItemId === deleteOrderData.laborItemId && item.laborId === deleteOrderData.laborId)
      ))
    }
    if (JSON.parse(localStorage.getItem('isQuality')) || !checkOrder) {
      removeDeletedOrderData()
    } else {
      localStorage.removeItem('removedQualityPCData')
    }
  }

  // function to check if key is present
  const hasValidOrderKey = (obj) => {
    const keysToCheck = ['orderMaterialId', 'orderProductId', 'orderLaborId'];
    return keysToCheck.some(key => obj.hasOwnProperty(key) && obj[key] > 0);
  }

  // function called for delete api
  const handleConfirmDeleteSubmit = () => {
    if (!hasValidOrderKey(deleteOrderData) && (JSON.parse(localStorage.getItem('isQuality')) || !checkOrder)) {
      removeGridData()
      setConfirmDeleteModal(false)
    } else if (hasValidOrderKey(deleteOrderData) && !JSON.parse(localStorage.getItem('isQuality'))) {
      let checkFlag = deleteOrderData.orderMaterialId ? true : false
      if(deleteOrderData.orderMaterialId) {
        deleteOrderMaterialData(auth[0].token, deleteOrderData.orderMaterialId, checkFlag)
      } else if(deleteOrderData.orderProductId) {
        deleteOrderMaterialData(auth[0].token, deleteOrderData.orderProductId, checkFlag)
      } else {
        deleteOrderLaborData(auth[0].token, deleteOrderData.orderLaborId)
      }
    } else if (JSON.parse(localStorage.getItem('isQuality')) || !checkOrder) {
      removeGridData()
      setConfirmDeleteModal(false)
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (data) => {
    if(data.orderLaborId) {
      setDeleteOrder('labor')      
    } else {
      setDeleteOrder('material')
    }
    setDeleteOrderData(data)
    setConfirmDeleteModal(true)
  }

  // handle remove material data
  const handleMaterialDeleteClick = (data) => {
    showConfirmDeleteModal(data)
  }

  // handle remove labor data
  const handleLaborDeleteClick = (data) => {
    showConfirmDeleteModal(data)
  }

  // handle cancel click
  const handleCancelClick = () => {
    sessionStorage.removeItem('quality-order-img');
    localStorage.removeItem('quality-order');
    localStorage.setItem("Qualityorder",0)
    navigate(`/existing-orders`)
  }

  // function to format a number with commas every 3 digits
  const handleFormat = (number) => {
    if (!number) return 0.00;
    return number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  const handleChangeUpdateShortageReasons = (e, item, jobNo) =>{
    const { checked } = e.target;
    // Store pending changes
    const reasonData = {
      orderReasonId: item.orderShortageReasonId,
      reasonId: item.shortageReasonId,
      orderDetailId: item.orderShortageDetailId,
      isSelected: checked,
      reason: item.shortageReason,
      jobNo: jobNo
    };

    // Update or add to pending reasons
    setPendingShortageReasons(prev => {
      const existingIndex = prev.findIndex(r => r.orderReasonId === item.orderShortageReasonId);
      const originalSelected = !!item.isSelected;
      const isBackToOriginal = checked === originalSelected;

      if (isBackToOriginal) {
        if (existingIndex >= 0) {
          const updated = [...prev];
          updated.splice(existingIndex, 1);
          return updated;
        }
        return prev;
      }

      if(existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = reasonData;
        return updated;
      }
      return [...prev, reasonData];
    });

    item.isSelected = checked;
  }

  // handle update quality reason
  const handleUpdateQualityReason = (e, item, jobNo) =>{
    const { checked } = e.target;
    // Store pending changes
    const reasonData = {
      orderReasonId: item.orderQualityReasonId,
      reasonId: item.qualityReasonId,
      orderDetailId: item.orderQualityDetailId,
      isSelected: checked,
      reason: item.qualityReason,
      jobNo: jobNo
    };
    // Update or add to pending reasons
    setPendingQualityReasons(prev => {
      const existingIndex = prev.findIndex(r => r.orderReasonId === item.orderQualityReasonId);
      const originalSelected = !!item.isSelected;
      const isBackToOriginal = checked === originalSelected;

      if (isBackToOriginal) {
        if (existingIndex >= 0) {
          const updated = [...prev];
          updated.splice(existingIndex, 1);
          return updated;
        }
        return prev;
      }

      if(existingIndex >= 0) {
        const updated = [...prev];
        updated[existingIndex] = reasonData;
        return updated;
      }
      return [...prev, reasonData];
    });
    item.isSelected = checked;
  }

  // Helper function to determine if a shortage checkbox should be checked
  const isShortageReasonChecked = (item) => {
    // Check if this item has pending changes
    const pendingItem = pendingShortageReasons.find(p => p.orderReasonId === item.orderShortageReasonId);

    if (pendingItem) {
      // Use pending state if available
      return pendingItem.isSelected;
    }

    // Otherwise use original state
    return item.isSelected || false;
  };

  const hasShortageReasonPendingChanges = (shortageData) => {
    if (!shortageData?.orderShortageReasons || pendingShortageReasons.length === 0) {
      return false;
    }

    return shortageData.orderShortageReasons.some(reason =>
      pendingShortageReasons.some(pending => pending.orderReasonId === reason.orderShortageReasonId)
    );
  };

  // Helper function to determine if a quality checkbox should be checked
  const isQualityReasonChecked = (item) => {
    // Check if this item has pending changes
    const pendingItem = pendingQualityReasons.find(p => p.orderReasonId === item.orderQualityReasonId);

    if (pendingItem) {
      // Use pending state if available
      return pendingItem.isSelected;
    }

    // Otherwise use original state
    return item.isSelected || false;
  };

  const hasQualityReasonPendingChanges = (qualityData) => {
    if (!qualityData?.orerQaulityReason || pendingQualityReasons.length === 0) {
      return false;
    }

    return qualityData.orerQaulityReason.some(reason =>
      pendingQualityReasons.some(pending => pending.orderReasonId === reason.orderQualityReasonId)
    );
  };

  // Save shortage reasons
  const handleSaveShortageReasons = (shortageData) => {
    if(!shortageData?.orderShortageReasons || shortageData.orderShortageReasons.length === 0) {
      toast.error("No reasons to save");
      return;
    }
    const selectedCount = shortageData.orderShortageReasons.filter(item => item.isSelected).length;
    if(selectedCount === 0) {
      toast.error("Please select atleast one reason!");
      return;
    }
    // Collect ALL reasons with their current state
    const orderReasons = shortageData.orderShortageReasons.map(item => ({
      orderReasonId: item.orderShortageReasonId,
      reason: item.shortageReason,
      isSelected: isShortageReasonChecked(item),
      reasonId: item.shortageReasonId,
      orderDetailId: item.orderShortageDetailId,
      jobNo: shortageData.jobNo
    }));

    const payload = {
      orderReasons: orderReasons
    };

    // Debug logging (remove after verification)
    // console.log('Save Shortage Reasons - Payload:', selectedCount, shortageData, JSON.stringify(payload, null, 2));

    updateChildReasonRequest(auth[0].token, payload);
    setPendingShortageReasons(prev => prev.filter(pending =>
      !shortageData.orderShortageReasons.some(item => item.orderShortageReasonId === pending.orderReasonId)
    ));
    toast.success("Shortage reasons updated successfully");
  };

  // Save quality reasons
  const handleSaveQualityReasons = (qualityData) => {
    if(!qualityData?.orerQaulityReason || qualityData.orerQaulityReason.length === 0) {
      toast.error("No reasons to save");
      return;
    }

    const selectedCount = qualityData.orerQaulityReason.filter(item => item.isSelected).length;
    if(selectedCount === 0) {
      toast.error("Please select atleast one reason!");
      return;
    }

    // Collect ALL reasons with their current state
    const orderReasons = qualityData.orerQaulityReason.map(item => ({
      orderReasonId: item.orderQualityReasonId,
      reason: item.qualityReason,
      isSelected: isQualityReasonChecked(item),
      reasonId: item.qualityReasonId,
      orderDetailId: item.orderQualityDetailId,
      jobNo: qualityData.jobNo
    }));

    const payload = {
      orderReasons: orderReasons
    };

    // Debug logging (remove after verification)
    // console.log('Save Quality Reasons - Payload:', JSON.stringify(payload, null, 2));

    updateChildReasonRequest(auth[0].token, payload);
    setPendingQualityReasons(prev => prev.filter(pending =>
      !qualityData.orerQaulityReason.some(item => item.orderQualityReasonId === pending.orderReasonId)
    ));
    toast.success("Quality reasons updated successfully");
  };

  // no. of checkboxes in a row/column
  const chunkArray = (array, size) =>
    array.reduce((acc, _, i) =>
      i % size === 0 ? [...acc, array.slice(i, i + size)] : acc, []);

  // Reason for Shortage checkboxs
  const ShortageReasonsComponent = ( shortageReasons, jobNo ) => {
    const itemsPerColumn = 1;
    const chunks = chunkArray(shortageReasons, itemsPerColumn);

    return (
      <Row>
        {chunks.map((chunk, chunkIndex) => (
          <Col md={4} key={`chunk-${chunkIndex}`}>
            <Form.Group>
              {chunk.map((item, itemIndex) => (
                <Form.Check
                  key={`item-${item.shortageReasonId}-${itemIndex}`}
                  type="checkbox"
                  id={`custom-switch-${item.shortageReasonId}`}
                  onChange={(e) => handleChangeUpdateShortageReasons(e, item, jobNo)}
                  checked={isShortageReasonChecked(item)}
                  label={item.shortageReason}
                />
              ))}
            </Form.Group>
          </Col>
        ))}
      </Row>
    );
  };

  // reason for qulaity checkbox
  const handleQualityReasons = (qualityReasons, jobNo) => {
    const itemsPerColumn = 1;
    const chunks = chunkArray(qualityReasons, itemsPerColumn);

    return (
      <Row>
        {chunks.map((chunk, chunkIndex) => (
          <Col md={4} key={`chunk-${chunkIndex}`}>
            <Form.Group>
              {chunk.map((item, itemIndex) => (
                <Form.Check
                  key={`item-${item.orderQualityReasonId}-${itemIndex}`}
                  type="checkbox"
                  id={`custom-switch-${item.orderQualityReasonId}`}
                  onChange={(e) => handleUpdateQualityReason(e, item, jobNo)}
                  checked={isQualityReasonChecked(item)}
                  label={item.qualityReason}
                />
              ))}
            </Form.Group>
          </Col>
        ))}
      </Row>
    );
  };

  // Create a Date object from the string
  function extractDate(dateString) {
    const dateObj = new Date(dateString);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const formattedDate = `${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}-${year}`;
    return formattedDate;
  }

  // handle click make change
  const handleMakeChangeModalClose = (e) => {
    e.preventDefault()
    if (rescheduleData.RescheduleChoicesId && startDate) {
      let payload = {
        "JobNo": parseInt(jobNum),
        "Reason": rescheduleData.RescheduleChoicesId,
        "Note": rescheduleData.changeJobNotes,
        "OrderInstallationDate": startDate ? extractDate(startDate) : null,
        "CreatedBy": parseFloat(auth[0].userId)
      }
      saveCustomerOrderRescheduleData(auth[0].token, payload)
    } else {
      if (!rescheduleData.RescheduleChoicesId) {
        toast.error('Rescheduled reason is required')
      } else if (!startDate) {
        toast.error('Rescheduled date is required')
      }
    }
  }

  // handle installation date
  const handleInstallationDate = (customerOrderData) => {
    let tempDate = customerOrderData?.orderInstallationDetails && customerOrderData?.orderInstallationDetails.InstallationDate ? handleFormatDate(customerOrderData?.orderInstallationDetails.InstallationDate) : ""
    return tempDate
  }

  // handle rescheduled data
  const handleFetchRescheduledData = () => {
    fetchCustomerOrderRescheduledData(auth[0].token, customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId)
  }

  // function to handle Reschedule click
  const handleReschedule = () => {
    handleFetchRescheduledData()
    setChangeJobHeader('Reschedule')
  }

  // handle shortage data
  const handleGetShortageReason = () => {
    getShortageReasonRequest(auth[0].token, '')
  }

  // function to handle Shortage Click
  const handleShortage = () => {
    handleGetShortageReason()
    setChangeJobHeader('Shortage')
  }

  // handle quality
  const handleQuality = () => {
    getQualityReasonRequest(auth[0].token, '')
    sessionStorage.removeItem('quality-order-img');
    localStorage.removeItem('quality-order');
    localStorage.setItem('isQuality', true)
    sessionStorage.removeItem('hasQualityWalksSelected')
    setChangeJobHeader('Quality')
  }

  // handle click property name
  const handlePropertyClickForOrdering = (customer) => {
    setProcessStart(true)
    let url = customer?.crossDomainLink
    console.log('---customer---')
    localStorage.setItem("place-order-contactInfoId", customer?.contactInfoId)
    let modified_url = url.replace("select-plan", "property-options")
    let authValue = JSON.parse(localStorage.getItem('geoErp'))
    let uniqueChannelName = `${modified_url}&uniqueChannelName=${authValue[0].uniqueChannelName}&editUnitId=${state.newUnitId}&editUnitTypeId=${state.newUnitTypeId}`
    let orderVariant = localStorage.getItem('order-VariantId') ?? 0;
    if(orderVariant !== 'undefind' && orderVariant > 0){
      uniqueChannelName = `${uniqueChannelName}&order-VariantId=${orderVariant}`;
    }
    let hasQualityWalksSelected = sessionStorage.getItem('hasQualityWalksSelected') ?? false;
    if(hasQualityWalksSelected !== 'undefind' && hasQualityWalksSelected){
      uniqueChannelName = `${uniqueChannelName}&isQualityWalks=${hasQualityWalksSelected}`;
      sessionStorage.removeItem('hasQualityWalksSelected')
    }
    // uniqueChannelName = uniqueChannelName.replace("https://blue.order.s10drd.com", "http://192.168.1.145:3030");
    // uniqueChannelName = uniqueChannelName.replace("https://order.s10drd.com", "http://192.168.1.137:3030");
    console.log('--uniqueChannelName--', hasQualityWalksSelected, uniqueChannelName)
    setIsOrderingUrl(uniqueChannelName)
    // handlePropertyModalOpen()
  }

  // useMemo(() => {
  //   if (processStart) {
  //     let authValue = JSON.parse(localStorage.getItem('geoErp'))
  //     let channel = pushervalue.subscribe(authValue[0]?.uniqueChannelName);
  //     localStorage.setItem('Existing_Orders', JSON.parse(false))
  //     channel.bind("update-order-status", (data) => {
  //       if(data?.PusherTrigger === "installation-detail-status") {
  //         // navigate(`/place-order/order-confirmation/contactInfoId=${localStorage.getItem("place-order-contactInfoId")}/unitId=${data?.UnitId}/jobNum=${data?.JobNum}`)
  //         window.location.href = `http://localhost:3000/place-order/order-confirmation/contactInfoId=${localStorage.getItem("place-order-contactInfoId")}/unitId=${data?.UnitId}/jobNum=${data?.JobNum}`
  //         // handlePropertyModalClose()
  //       }
       
  //     });
  //   }
  // }, [processStart]);

  useEffect(() => {
    if (processStart) {
      let authValue = JSON.parse(localStorage.getItem('geoErp'));
      let channel = pushervalue.subscribe(authValue[0]?.uniqueChannelName);
      localStorage.setItem('Existing_Orders', JSON.stringify(false));
      
      channel.bind("update-order-status", (data) => {
        console.log('--data---', data)

        if (data?.PusherTrigger === "EXECUTED" && data?.PngImage) { // check quality order image when partial order
          let quality_order_img = data.PngImage
          sessionStorage.setItem('quality-order-img', quality_order_img)
        }
        if (data?.PusherTrigger === "installation-detail-status") {
          toast.success('Order Successful')
          let quality_response = data ? data : null
          if(!sessionStorage.getItem('quality-order-img') && quality_response?.FloorPlan){
            sessionStorage.setItem('quality-order-img', quality_response?.FloorPlan)
          }
          localStorage.setItem('quality-order', JSON.stringify(quality_response))
          setTimeout( () => {
            // navigate(`/place-order/order-confirmation/${localStorage.getItem("place-order-contactInfoId")}/${data?.UnitId ? data?.UnitId : 0}/${data?.JobNum ? data?.JobNum : 0}`);
            navigate(`/place-order/order-confirmation/contactInfoId=${localStorage.getItem("place-order-contactInfoId")}/unitId=${data?.UnitId ? data?.UnitId : 0}/jobNum=${data?.JobNum ? data?.JobNum : 0}`);
            navigate(0);
          }, 1000)
        }
				if(data?.PusherTrigger === "close-ordering-popup") {
					localStorage.setItem('Existing_Orders', JSON.parse(true))
          localStorage.setItem('Existing-Orders-Page', JSON.parse(true))
          localStorage.setItem('isQuality', false)
          localStorage.setItem("Qualityorder",0)
          sessionStorage.removeItem('quality-order-img');
          localStorage.removeItem('quality-order');
          // navigate(`/place-order/order-confirmation/${localStorage.getItem("place-order-contactInfoId")}/${parseInt(JSON.parse(localStorage.getItem('quality-UnitId')))}/${parseInt(JSON.parse(localStorage.getItem('quality-JobNum')))}`)
          navigate(`/place-order/order-confirmation/contactInfoId=${localStorage.getItem("place-order-contactInfoId")}/unitId=${parseInt(JSON.parse(localStorage.getItem('quality-UnitId')))}/jobNum=${parseInt(JSON.parse(localStorage.getItem('quality-JobNum')))}`)
          setCheckOrder(false)
          window.location.reload();
				}
      });
    }
  }, [processStart]);

  // handle Odering model
  const handleOrdering = () => {
    handleMakeChangeModalOpen()
    handlePropertyClickForOrdering(customerData[0])
    setChangeJobHeader('Ordering')
  }

  useEffect(() => {
    if (saveOrderShortage && saveOrderShortage.result) {
      if (changeJobHeader === 'Shortage' && saveOrderShortage.result[0] === 'Order shortage saved successfully') {
        toast.success(saveOrderShortage.result[0])
        let tmpIsDeleted = isOrderDeleted()
        fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
        fetchOrderInstallationMaterial(auth[0].token, jobNum)
        fetchOrderInstallationOrder(auth[0].token, jobNum)
        handleMakeChangeClose()
      } else if (changeJobHeader === 'Shortage' && saveOrderShortage.error) {
        toast.error(saveOrderShortage.error)
      }
    }
  }, [saveOrderShortage])

  const handleAddOn = () => {
    fetchCustomerOrderAddOnDetails(auth[0].token, jobNum)
    localStorage.setItem("addOnModal",JSON.stringify({"addOnModalOpen":true,"addNewMaterialItemClicked":false,"addNewLaborItem":false}))
    setChangeJobHeader('Add On')
  }

  useEffect(() => {
    if(localStorage.getItem("addOnModal")){
      localStorage.setItem("addOnModal",JSON.stringify({"addOnModalOpen":false,"addNewMaterialItemClicked":false,"addNewLaborItem":false}))
    }
    loadLocalStorageDataSetup()
    loadLocalStorageLaborDataSetup()
  },[])

  // handle reschedule cancel button
  const handleRescheduleCancel = () => {
    setChangeJobHeader('Change Job')
    setStartDate()
    setRescheduleData({
      'RescheduleChoicesId': '',
      'changeJobNotes': ''
    })
    localStorage.removeItem('isQuality')
  }

  // handle add on form data
  const handleAddOnFormChange = (e) => {
    const { id, value } = e.target
    setAddOnData({
      ...addOnData,
      [id]: value
    })
  }

  // handle addon submit details
  const handleAddOnSubmit = (data) => {
    if (addOnData.approvedBy && addOnData.approvedBy.length > 0) {
      handleAddonButtonDisability(true)
      let payload = {
        "JobNo": parseInt(jobNum),
        "orderAddOnDetail": {
          "ApprovedBy": addOnData.approvedBy,
          "Description": addOnData.description,
          "EnteredBy": auth[0].userId
        },
        "addOnProducts": data.addOnProducts,
        "addOnMaterials": data.addOnMaterials,
        "addOnLabors": data.addOnLabors
      }
      saveCustomerOrderAddOnDetails(auth[0].token, payload)
    } else {
      toast.error('Please fill all the required fields')
      handleAddonButtonDisability(false)
    }
  }

  // handle addon submit details
  const handleorderShortageSubmit = (data) => {
    if (data) {
      let updatedData = {
        ...data,
        orderShortageDetail: {
          ...data.orderShortageDetail,
          enteredBy: auth[0].userId, 
        },
      };
      saveOrderShortageRequest(auth[0].token, updatedData)
    } else {
      toast.error('Please fill all the required fields')
    }
  }

  // handle add on cancel
  const handleAddOnCancel = () => {
    setChangeJobHeader('Change Job')
    setAddOnData({
      'approvedBy': '',
      'description': ''
    })
    fetchOrderInstallationMaterial(auth[0].token, jobNum)
    fetchOrderInstallationOrder(auth[0].token, jobNum)
    localStorage.removeItem('isQuality')
    handleAddonButtonDisability(false)
  }

  // function to handle sum of line price
  const handleAddOnSum = (addOnData) => {
    let sum = 0
    if (addOnData && addOnData.length > 0) {
      addOnData.map(data => {
        if (data?.linePrice) {
          sum += data.linePrice
        }
      })
    }
    return sum
  }

  // Function to handle add on total
  const handleAddOnTotal = (data) => {
    let dataLength = Object.keys(data).length;
    if (dataLength && dataLength > 0) {
      let addOnTotal = 0;
      let addOnOrgTotal = 0
      if (data?.products && data?.products.length > 0) {
        let productSum = handleAddOnSum(data?.products)
        addOnTotal += productSum
        // addOnOrgTotal += productSum
      }
      if (data?.materials && data?.materials.length > 0) {
        let materialSum = handleAddOnSum(data?.materials)
        addOnTotal += materialSum
      }
      if (data?.labors && data?.labors.length > 0) {
        let laborSum = handleAddOnSum(data?.labors)
        addOnTotal += laborSum

        data?.labors.map(item => {
          if (item?.linePrice) {
            addOnOrgTotal += item.lineCost
          }
        })
      }

      return [addOnTotal.toFixed(2), addOnOrgTotal.toFixed(2)]
    }
  }

  // function to calculate the totalPrice 
  const calculateTotal = (material, product, labor) =>{
    let totalAmount = 0;
    let totalOrgAmount = 0;
    if(material.length !== 0){
      for(let obj of material){
        totalAmount += parseFloat(obj?.linePrice)
      }
    }
    if(product.length !== 0){
      for(let obj of product){
        totalAmount +=  parseFloat(obj.linePrice)
        // totalOrgAmount += parseFloat(obj.linePrice)
      }
    }
    if(labor.length !== 0){
      for(let obj of labor){
        totalAmount +=  parseFloat(obj.linePrice)
        totalOrgAmount +=  parseFloat(obj.lineCost)
      }
    }
    return [parseFloat(totalAmount).toFixed(2), parseFloat(totalOrgAmount).toFixed(2)];
  }

  //function to calculate quality total
  const handleQualityTotal = (customerQualitydata, qualityType) => {
    const calculateTotal = (data, key) =>
      (data || []).reduce((sum, obj) => sum + parseFloat(obj?.[key] || 0), 0);

    let totalAmount = calculateTotal(customerQualitydata?.orderQualityLabor, qualityType);
    if(qualityType === 'unitPrice' || qualityType === 'linePrice'){
      totalAmount += calculateTotal(customerQualitydata?.orderQualityProduct, qualityType);
      totalAmount += calculateTotal(customerQualitydata?.orderQualityMaterial, qualityType);
    }
    return totalAmount.toFixed(2);
  }

  // aggregate financial metrics for a quality entry
  const getQualityFinancials = (customerdata, dataType) => {
    const parseNumeric = (value) => {
      const parsedValue = parseFloat(value);
      return Number.isFinite(parsedValue) ? parsedValue : 0;
    };

    let sections = [
      customerdata?.orderQualityProduct || [],
      customerdata?.orderQualityMaterial || [],
      customerdata?.orderQualityLabor || []
    ];
    if(dataType === 'shortage'){
      sections = [
        customerdata?.orderShortageProduct || [],
        customerdata?.orderShortageMaterial || [],
        customerdata?.orderShortageLabor || []
      ];
    }
    if(dataType === 'addons'){
      sections = [
        customerdata?.products || [],
        customerdata?.materials || [],
        customerdata?.labors || []
      ];
    }
    const getItemValue = (item, keys) => {
      for (const key of keys) {
        const value = item?.[key];
        if (value !== undefined && value !== null) {
          return value;
        }
      }
      return 0;
    };

    const sumByKeys = (keys) =>
      sections.reduce(
        (sectionTotal, section) =>
          sectionTotal + section.reduce((itemTotal, item) => itemTotal + parseNumeric(getItemValue(item, keys)), 0),
        0
      );

    const totalSalesPrice = sumByKeys(['linePrice']);
    const totalCost = sumByKeys(['lineCost']);
    const totalProfit = totalSalesPrice - totalCost;
    const totalGPM = totalSalesPrice > 0 ? (totalProfit / totalSalesPrice) * 100 : 0;

    return {
      totalSalesPrice,
      totalCost,
      totalProfit,
      totalGPM
    };
  }

  // function to tract state change
  const handleStateChange = () => {
    setIsStateChanged(!isStateChanged)
  }
  const prevImageUrl = useRef(null); // Store previous image URL
  const [base64Image, setBase64Image] = useState("");
  const ImageContainer = ({ imageUrl, customerOrderData }) => {

    //  Convert createdOn date only once when data changes
    useEffect(() => {
        // const createdOn = customerOrderData?.[0]?.orderInstallationDetails?.CreatedOn;
        const createdOn = customerOrderDetails?.[0]?.orderInstallationDetails?.CreatedOn;
        if (createdOn) {
          const [date, time] = createdOn.split('T');
          const formattedTime = time ? time.slice(0, 8) : '';
          setCreatedDate(date);
          setCreatedTime(formattedTime);
        }
        else{
          const orderNow = new Date();
          const usDateFormat = orderNow.toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            timeZone: "UTC"
          });
          const usTimeFormat = orderNow.toLocaleString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            timeZone: "UTC",
            hour12: true, // Ensures AM/PM format
          });
          setCreatedDate(usDateFormat);
          setCreatedTime(usTimeFormat);
        }
    }, [customerOrderData]); //  Runs only when `customerOrderData` changes

    // Convert Image URL to Base64
    
    useEffect(() => {
        if (!imageUrl) {
          setBase64Image("");
          prevImageUrl.current = null;
          return;
        }

        if (prevImageUrl.current === imageUrl) {
          return;
        }
        prevImageUrl.current = imageUrl;

        if (imageUrl.startsWith('data:image')) {
          setBase64Image(imageUrl);
          return;
        }

        if (/^https?:\/\//i.test(imageUrl)) {
          setBase64Image(imageUrl);
          return;
        }

        fetch(imageUrl, { mode: 'cors' })
            .then((response) => response.blob())
            .then((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => setBase64Image(reader.result);
                reader.readAsDataURL(blob);
            })
            .catch((error) => {
              console.error("Error converting image to Base64:", error);
              setBase64Image(imageUrl);
            });
    }, [imageUrl]); // Runs only when `imageUrl` changes

    return (
        <img id="floorimage"
            className="img-fluid view-img"
          src={base64Image}
            alt="Floorplan"
        />
    );
  };

  const [ordBase64Image, setOrdBase64Image] = useState("");
  const LogoImageContainer = ({ imageUrl }) => {
    // Convert Image URL to Base64
    if (!imageUrl) return true;
    useEffect(() => {
        if (!imageUrl) {
          setOrdBase64Image("");
          return;
        }

        if (imageUrl.startsWith('data:image')) {
          setOrdBase64Image(imageUrl);
          return;
        }

        if (/^https?:\/\//i.test(imageUrl)) {
          setOrdBase64Image(imageUrl);
          return;
        }

        fetch(imageUrl, { mode: 'cors' })
            .then((response) => response.blob())
            .then((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => setOrdBase64Image(reader.result);
                reader.readAsDataURL(blob);
            })
            .catch((error) => {
              console.error("Error converting image to Base64:", error);
              setOrdBase64Image(imageUrl);
            });
    }, [imageUrl]); // Runs only when `imageUrl` changes
    const storePhone = customerData?.[0]?.storeContactNo;
    return (
      <>
        {ordBase64Image && (<><img id="store-pdf-logo"
          className="img-fluid view-img"
          src={ordBase64Image}
          alt="Store Logo"
          style={{'display':'none', 'width': '200px'}}
        />
        <div className="store_phone" style={{'display':'none'}}>
        <div className="d-flex align-items-center gap-2 w-100 justify-content-center p-1">
        <Icon size={16} icon={ic_phone}/>
          <span className="storePhone">{storePhone ? storePhone : ''}</span>
        </div>
        </div></>)}
      </>
    );
  };

  // function to handle quality date
  const handleQualityInstallationDate = (data) => {
    return formatDate(data?.orderQualityDetail?.installationDate)
  }

  // function to handle quality status data
  const handleQualityStatus = (data) => {
    return data?.orderQualityDetail?.qualityStatus
  }

  const handleRescheduleDate = (date) => {
    return (date) ? formatDate(date) : '';
  }

  // common function to manage reschedule date
  const handleRescheduleDataChange = (idx, date, dataType) => {
    if (dataType === 'addons') {
      setRescheduleAddonsData((prev) => ({ ...prev, [idx]: date }));
    }
    if (dataType === 'shortage') {
      setRescheduleShortageData((prev) => ({ ...prev, [idx]: date }));
    }
    if (dataType === 'quality') {
      setRescheduleQualityData((prev) => ({ ...prev, [idx]: date }));
    }
  };

  const formatDateToLocalMidnight = (inputDate) => {
    const date = new Date(inputDate);
    date.setHours(0, 0, 0, 0); // Set time to 00:00:00

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}T00:00:00`;
  };

  const getPendingRescheduleDate = (idx, dataType) => {
    if (dataType === 'addons') {
      return rescheduleAddonsData?.[idx];
    }
    if (dataType === 'shortage') {
      return rescheduleShortageData?.[idx];
    }
    if (dataType === 'quality') {
      return rescheduleQualityData?.[idx];
    }
    return null;
  }

  const getExistingRescheduleDate = (data, dataType) => {
    if (!data) return null;
    if (dataType === 'addons') {
      return data?.rescheduleDate || data?.addOnDetail?.rescheduleDate || null;
    }
    if (dataType === 'shortage') {
      return data?.rescheduleDate || data?.orderShortageDetail?.rescheduleDate || null;
    }
    if (dataType === 'quality') {
      return data?.rescheduleDate || data?.orderQualityDetail?.rescheduleDate || null;
    }
    return null;
  }

  const normalizeRescheduleDateValue = (value) => {
    if (!value) return null;
    return formatDateToLocalMidnight(value);
  }

  const hasReschedulePendingChanges = (idx, data, dataType) => {
    const pendingValue = getPendingRescheduleDate(idx, dataType);
    if (!pendingValue) {
      return false;
    }
    const existingValue = getExistingRescheduleDate(data, dataType);
    return normalizeRescheduleDateValue(pendingValue) !== normalizeRescheduleDateValue(existingValue);
  }

  const handleRescheduleSaveData = (idx, dataType, data) => {
    // check if the order is been released on BC
    if(isOrderReleased) {
      return;
    }

    let tmpJobNo = data?.jobNo || 0;
    let payload = {
      "jobNo": tmpJobNo,
      "reason": "Reschedule Date",
      "note": "Reschedule Date",
      "createdBy": auth[0].userId
    }
    let tmpDate = null;
    if(dataType === 'addons'){
      tmpDate = rescheduleAddonsData?.[idx] || null;
      payload = {...payload, 
        orderAddOnDetailId: data?.addOnDetail?.orderAddOnDetailId || 0,
        rescheduleDate: formatDateToLocalMidnight(tmpDate)
      }
    }
    if(dataType === 'shortage'){
      tmpDate = rescheduleShortageData?.[idx] || null;
      payload = {...payload, 
        orderShortageDetailId: data?.orderShortageDetail?.orderShortageDetailId || 0,
        rescheduleDate: formatDateToLocalMidnight(tmpDate)
      };
    }
    if(dataType === 'quality'){
      tmpDate = rescheduleQualityData?.[idx] || null;
      payload = {...payload, 
        qualityOrderInstallationDetailId: data?.orderQualityDetail?.orderQualityInstallationDetailId || 0,
        rescheduleDate: formatDateToLocalMidnight(tmpDate)
      };
    }
    if(tmpDate){
      saveRescheduleOrderRequest(auth[0].token, payload, dataType)
      if(dataType === 'addons'){
        const updatedAddons = customerOrderDetails[0].orderAddOns.map((item, i) => {
          if (i === idx) {
            return {
              ...item,
              rescheduleDate: formatDateToLocalMidnight(tmpDate)
            };
          }
          return item;
        });

        // Update main data and state
        customerOrderDetails[0].orderAddOns = updatedAddons;
        setOrderAddonsList(updatedAddons);
      }
      if(dataType === 'shortage'){
        const updatedShortage = customerOrderDetails[0].orderShortage.map((item, i) => {
          if (i === idx) {
            return {
              ...item,
              rescheduleDate: formatDateToLocalMidnight(tmpDate)
            };
          }
          return item;
        });

        // Update main data and state
        customerOrderDetails[0].orderShortage = updatedShortage;
        setOrderShortageList(updatedShortage);
      }
      if(dataType === 'quality'){
        const updatedQuality = customerOrderDetails[0].orderQuality.map((item, i) => {
          if (i === idx) {
            return {
              ...item,
              rescheduleDate: formatDateToLocalMidnight(tmpDate)
            };
          }
          return item;
        });

        // Update main data and state
        customerOrderDetails[0].orderQuality = updatedQuality;
        setOrderQualityList(updatedQuality);
      }
      setCustomerOrderData(customerOrderData);


      setRescheduleAddonsData({});
      setRescheduleShortageData({});
      setRescheduleQualityData({});
    }
  }

  const hideConfirmChangesModal = () => {
    setDeletePropertyModalOpen(false)
  }

  const handleConfirmSubmit = () => {
    setDeletePropertyModalOpen(false)
    setDeletePropertyData({})
    let job_poststr = null;
    switch (deletePropertyData?.dataType) {
      case "addons":
        job_poststr = `${deletePropertyData?.orderData?.addOnDetail?.originalJobNo}`
        break;
      case "shortage":
        job_poststr = `${deletePropertyData?.orderData?.orderShortageDetail?.originalJobNo}`
        break;
      case "quality":
        job_poststr = `${deletePropertyData?.orderData?.orderQualityDetail?.originalJobNo}`
        break;
      default:
        // default code block
    }
    if(job_poststr){
      let payload = {
        'JobNo': [job_poststr]
      };
      console.log('--handleConfirmSubmit--')
      deleteSubOrder(auth[0].token, payload);
      setDeletePropertyData({})
    }
  }

  const handleRemoveRow = (index, delType,data) => {
    setDeletePropertyData({
      propertyId: index,
      orderData: data,
      dataType: delType
    })
    setDeletePropertyModalOpen(true)
  };

  // function to handle quality status change
  const handleQualityStatusChange = (e, customerQualitydata) => {
    const { value } = e.target
    let payload = {
      "installationDate": formatDate(customerQualitydata?.orderQualityDetail?.installationDate),
      "status": value,
      "orderQualityDetailId": customerQualitydata?.orderQualityDetail?.orderQualityDetailId
    }
    updateQualityDetail(auth[0].token, payload)
  }

  // handle cancel order
  const handleCustomerOrderCancel = () => {
    let payload = {
      "JobNo": [parseInt(jobNum)]
    }
    customerOrderCancel(auth[0].token, payload)
  }

  useMemo(() => {
    if(updatedReschedule){
      let tmpMsg = 'Installation date rescheduled!';
      toast.success(tmpMsg)
    }
    if(rescheduleError && rescheduleRes?.result.length > 0){
      let tmpMsg = rescheduleRes?.result?.[0] || 'Failed to reschedule the installation date. Please try again.';
      toast.error(tmpMsg)
    }
    if(subOrderError){
      let tmpMsg = 'Change order cancellation failed. Please try again!';
      toast.error(tmpMsg)
    }
    if(isOrderUdpated){
      let tmpMsg = 'Order details updated!';
      toast.success(tmpMsg)
    }
  },[updatedReschedule, rescheduleError, subOrderError, isOrderUdpated])

  useEffect(() => {
    if(subOrderDeleted){
      let tmpMsg = 'Change order cancelled!';
      // Extract message from API response
      if(subOrderDeleted.result &&
         Array.isArray(subOrderDeleted.result) &&
         subOrderDeleted.result.length > 0 &&
         subOrderDeleted.result[0]) {
        tmpMsg = subOrderDeleted.result[0];
      } else if (subOrderDeleted.message) {
        tmpMsg = subOrderDeleted.message;
      } else if (subOrderDeleted.errorMessage) {
        tmpMsg = subOrderDeleted.errorMessage;
      } else if (subOrderDeleted.msg) {
        tmpMsg = subOrderDeleted.msg;
      }
      toast.success(tmpMsg)
      if (isAuthenticated) {
        fetchCustomerList(auth[0].token, "asc", 1, 1, { 'contactInfoId': contactInfoId }, auth[0].userId, false, false, false)
        getShortageReasonRequest(auth[0].token, '')
        let tmpIsDeleted = isOrderDeleted()
        fetchOrderInstallationDetail(auth[0].token, parseInt(jobNum) ? jobNum : qualityJobNo(), parseInt(jobNum) ? orderedPlaced() : true, tmpIsDeleted)
        if (!JSON.parse(localStorage.getItem('isQuality'))) {
          fetchOrderInstallationMaterial(auth[0].token, jobNum)
          fetchOrderInstallationOrder(auth[0].token, jobNum)
        }
        handlePlacedQuality()
        handleOrderedDetails()
      }
    }
  },[subOrderDeleted])

  const renderReasons = () => {
    let tmpLabel = ''
    let tmpBadges = ''
    if (typeof jobNum === "string" && jobNum.includes("-Q")) {
      tmpLabel = 'Reason for Quality'
      if(customerOrderData && customerOrderData?.[0]?.orderQuality?.length > 0){
        const selectedQualityReasons = customerOrderData?.[0]?.orderQuality?.[0]?.orerQaulityReason
          ?.filter(item => item?.isSelected)
          ?.map(item => item.qualityReason) ?? [];
        tmpBadges = <div className="badge-container">
          {selectedQualityReasons.map((reason, index) => (
            <span key={index} className="badge badge-pill badge-secondary">
              {reason}
            </span>
          ))}
        </div>
      }
    }
    if (typeof jobNum === "string" && jobNum.includes("-S")) {
      tmpLabel = 'Reason for Shortage';
      if(orderShortageList && orderShortageList?.length > 0){
        const selectedShortageReasons = orderShortageList?.[0]?.orderShortageReasons
          ?.filter(item => item?.isSelected)
          ?.map(item => item.shortageReason) ?? [];
        tmpBadges = <div className="badge-container">
          {selectedShortageReasons.map((reason, index) => (
            <span key={index} className="badge badge-pill badge-secondary">
              {reason}
            </span>
          ))}
        </div>
      }
    }
    if(tmpLabel !== '' && tmpBadges !==''){
      return <Form.Group className="row mb-2">
              <Form.Label htmlFor="jobNumber" className="form-label col-md-4">{tmpLabel}</Form.Label>
              <span className="value col-md-8" id="jobNumber">{tmpBadges}</span>
            </Form.Group>
    }
    else {
      return '';
    }
  }

  return (
    <MainWrapper id="pdfmainwrapper">
      {isProcessing || isLoading || isOrderLoading ? (<div className="loading-container"><div className="spinner-border"></div></div>) : null}
      {orderNav.show && (
        <div className="order-nav-bar d-flex justify-content-end align-items-center gap-2 mt-4 mb-2">
          <Link className="btn btn-primary me-1" to="/existing-orders"><Icon icon={ic_arrow_back} />Back</Link>
          <Button
            className="btn-primary"
            disabled={!orderNav.prev}
            onClick={() => goToOrder(orderNav.prev)}
            title="Previous order"
          >
            <Icon icon={ic_chevron_left} size={20} /> Previous
          </Button>
          <Button
            className="btn-primary"
            disabled={!orderNav.next}
            onClick={() => goToOrder(orderNav.next)}
            title="Next order"
          >
            Next <Icon icon={ic_chevron_right} size={20} />
          </Button>
        </div>
      )}
      <Container id="pdfcontainer" className="overflow-visible" >
        {customerOrderData && customerOrderData.map((data, index) => {
          const existingPurchaseOrder = data?.orderInstallationDetails?.PurchaseOrder ?? '';
          const isPurchaseOrderChanged = (state?.PurchaseOrder ?? '') !== existingPurchaseOrder;
          const existingDescription = data?.orderInstallationDetails?.Description ?? '';
          const existingInternalNotes = data?.orderInstallationDetails?.InternalNotes ?? '';
          const existingInstallerInstruction = data?.orderInstallationDetails?.InstallerInstruction
            ?? data?.orderInstallationDetails?.Instruction
            ?? '';
          const isInfoDetailChanged =
            (state?.description ?? '') !== existingDescription ||
            (state?.internalNotes ?? '') !== existingInternalNotes ||
            (state?.installerInstructions ?? '') !== existingInstallerInstruction;
          return (<Card className="mb-7" key={index} >
            <Card.Body >
              { checkOrder && !isQualityPlaced && !hasDeletedItems &&
                <div className="make-changes text-end mb-4">
                  <div data-bs-toggle="modal" onClick={handleMakeChangeClick} role="button" className="btn btn-primary">
                    Make Changes
                  </div>
                </div>
              }
              <Row className="justify-content-center">
                <Col md={9}>
                  <div className="order-detail px-0">
                    {customerData?.[0]?.storeLogo && (<Row className="my-3">
                      <Col md={6}>
                        <div className="plan-img">
                          <LogoImageContainer imageUrl={customerData?.[0]?.storeLogo}/>
                        </div>
                      </Col>
                    </Row>)}
                    <h3 className="mb-4">Order Details</h3>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="inst-date" className="col-md-4">Property Name</Form.Label>
                      <span className="value col-md-8" id="propertyname">{data?.orderInstallationDetails?.ShipToPropertyName}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="inst-date" className="form-label col-md-4">Address</Form.Label>
                      <span className="value col-md-8" id="address">{data?.orderInstallationDetails?.ShipToAddress}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="inst-date" className="form-label col-md-4">City</Form.Label>
                      <span className="value col-md-8" id="city">{data?.orderInstallationDetails?.ShipToCity}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="inst-date" className="form-label col-md-4">State</Form.Label>
                      <span className="value col-md-8" id="state">{data?.orderInstallationDetails?.ShipToState}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="inst-date" className="form-label col-md-4">Zip</Form.Label>
                      <span className="value col-md-8" id="zip">{data?.orderInstallationDetails?.ShipToZip}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="name" className="col-md-4">Requestor Name</Form.Label>
                      <span className="value col-md-8" id="name">{data?.orderInstallationDetails?.RequesterName}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="email" className="col-md-4">Requestor Email</Form.Label>
                      <span className="value col-md-8" id="email">{data?.orderInstallationDetails?.RequesterEmail}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="phone" className="form-label col-md-4">Requestor Phone Number</Form.Label>
                      <span className="value col-md-8" id="phone">{data?.orderInstallationDetails?.PhoneNo}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="inst-date" className="form-label col-md-4">Unit#</Form.Label>
                      <div className="col-md-8">
                        <Form.Control type="text" className="form-control col-md-8" name="newUnitId" id="newUnitId" onChange={handleChange} value={state.newUnitId} disabled={checkOrder ? true : false} />
                      </div>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="inst-date" className="form-label col-md-4">Unit Type</Form.Label>
                      <div className="col-md-8">
                        <Form.Control type="text" className="form-control" name="newUnitTypeId" id="newUnitTypeId" onChange={handleChange} value={state.newUnitTypeId} disabled={checkOrder ? true : false}/>
                      </div>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="inst-date" className="form-label col-md-4">Order Date & Time</Form.Label>
                      <span className="value col-md-8" id="inst-date">{(createdDate || createdTime) && `${handleFormatDate(createdDate)} ${createdTime} UTC`}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="inst-date" className="form-label col-md-4">Installation Date</Form.Label>
                      <span className="value col-md-8" id="inst-date">{handleInstallationDate(data)}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="description" className="form-label col-md-4">Description</Form.Label>
                      <div className="col-md-8">
                        <Form.Control as="textarea" className="form-control" name="description" id="description" onChange={handleChange} value={state.description} row={3}/>
                      </div>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="occupied" className="form-label col-md-4">Occupied</Form.Label>
                      <span className="value col-md-8" id="occupied">{data?.orderInstallationDetails?.Occupaied ? 'Yes' : 'No'}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="purchaseOrder" className="form-label col-md-4">Purchase Order</Form.Label>
                      <span className="value col-md-4" id="purchaseOrder">
                        <Form.Control type="text" className="form-control" name="PurchaseOrder" id="PurchaseOrder" onChange={handleChange} value={state.PurchaseOrder} />
                      </span>
                      {checkOrder && !hasDeletedItems && (<span className="value col-md-4" id="purchaseOrder">
                        <div data-bs-toggle="modal" role="button" id="updatePo" className={!isPurchaseOrderChanged ? "btn btn-primary me-2 disabled" : "btn btn-primary me-2"} disabled={!isPurchaseOrderChanged} onClick={handleUpdateOrderClick}>Save Purchase Order</div>
                      </span>)}
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="salesperson" className="form-label col-md-4">Salesperson</Form.Label>
                      <span className="value col-md-8" id="salesperson">{data?.orderInstallationDetails?.SalesPerson}</span>
                    </Form.Group>
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="jobNumber" className="form-label col-md-4">Job Number</Form.Label>
                      <span className="value col-md-8" id="jobNumber">{parseInt(jobNum) ? jobNum : qualityJobNo()}</span>
                    </Form.Group>
                    { isQualityPlaced && renderReasons() }
                    {checkOrder && <Form.Group className="row mb-2">
                      <Form.Label htmlFor="orderSubTotal" className="form-label col-md-4">Subtotal</Form.Label>
                      <span className="value col-md-8" id="orderSubTotal">{orderTotal ? handleFormat(parseFloat(orderTotal)) : null}</span>
                    </Form.Group>}
                    {checkOrder && <Form.Group className="row mb-2">
                      <Form.Label htmlFor="TotalTax" className="form-label col-md-4">Tax</Form.Label>
                      <div className="col-md-8">
                        <Form.Control type="text" className="form-control" name="TotalTax" id="TotalTax" onChange={handleChange} value={state.TotalTax} disabled={checkOrder ? true : false}/>
                      </div>
                      <span className="value col-md-8" id="zip"></span>
                    </Form.Group>}
                    <Form.Group className="row mb-2">
                      <Form.Label htmlFor="orderTotal" className="form-label col-md-4">Total</Form.Label>
                      <div className="col-md-8">
                        {orderTotal ? handleFormat(parseFloat(orderTotal) + parseFloat(state.TotalTax || 0)) : null}
                      </div>
                      <span className="value col-md-8" id="zip"></span>
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="internalNotes" className="form-label col-md-4">Internal Notes</Form.Label>
                      <div className="col-md-8">
                        <Form.Control type="text" className="form-control" name="internalNotes" id="internalNotes" onChange={handleChange} value={state.internalNotes} />
                      </div>
                    </Form.Group>
                    <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="installerInstructions" className="form-label col-md-4">Customer Instructions</Form.Label>
                      <div className="col-md-8">
                        <Form.Control type="text" className="form-control" name="installerInstructions" id="installerInstructions" onChange={handleChange} value={state.installerInstructions}/>
                      </div>
                    </Form.Group>
                    {checkOrder && !hasDeletedItems && (<Form.Group className="row mb-2">
                      <div className="col-md-8 offset-md-4 d-flex gap-2">
                        <Button
                          variant={isInfoDetailChanged ? 'btn btn-primary me-2' : 'btn btn-primary me-2 disabled'}
                          className="btn"
                          id="updateInfoDetail"
                          onClick={() => handleSaveOrderDetailFields(data?.orderInstallationDetails)}
                          disabled={!isInfoDetailChanged || !customerOrderData?.length || hasDeletedItems || isProcessing || isOrderLoading}
                        >
                          Save
                        </Button>
                      </div>
                    </Form.Group>)}
                    {customerData?.[0]?.installerNotes && <Form.Group className="row mb-2 pdf-optional">
                      <Form.Label htmlFor="installerNotes" className="form-label col-md-4">Installer Notes</Form.Label>
                      <span className="value col-md-8" id="installerNotes">{customerData?.[0]?.installerNotes}</span>
                    </Form.Group>}
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center align-items-center my-3 pdfPageBreak">
                {colorKeyItems.length > 0 && (
                  <Col md={3} id="colorKeyInfo" style={{display: 'none'}}>
                    <div style={{ border: '1px solid #000', padding: '12px 16px', display: 'inline-block', minWidth: '150px' }}>
                      <div style={{ textAlign: 'center', fontWeight: '600', marginBottom: '8px' }}>Key</div>
                      {colorKeyItems.map((item, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}>
                          <span style={{
                            display: 'inline-block',
                            width: '20px',
                            height: '20px',
                            backgroundColor: item.color,
                            flexShrink: 0,
                            marginRight: '8px'
                          }} />
                          <span>{`· ${item.name}`}</span>
                        </div>
                      ))}
                    </div>
                  </Col>
                )}
                <Col className="plan-img-container" md={6}>
                  <div className="plan-img">
                    <ImageContainer imageUrl={getMeasureImagePng()}/>
                  </div>
                </Col>
              </Row>
              <hr className="mt-0" />
              <div className="order-detail px-0 py-0">
                <h5 className="mb-3 pdfPageBreak">Material</h5>
                <div className="fixTableHead ">
                  <Table bordered className="mb-0 t-scroll order-material-pdf">
                    <thead>
                      <tr>
                        <th>Qty</th>
                        <th>Unit</th>
                        <th>Private Name</th>
                        <th>Style</th>
                        <th>Color</th>
                        <th>Unit Price</th>
                        <th>Line Price</th>
                        { !checkOrder &&
                          <th id="pdfactionmaterial">Actions</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {materialListData && materialListData?.length > 0 && materialListData.map((data, index) => (
                        <tr key={index}>
                          <td width="110">
                            {data.isInsufficientItem && <div className="inventry-msg">
                              Insufficient Inventory: {data.insufficientQty}
                            </div>}
                            <Input 
                              ids={`materialQuantityItem`} 
                              validate={false}
                              handleChange={e=>handleMaterialItemChange(e, data, 'quantity')}
                              handleBlur={e=>handleMaterialQuantityBlur(e, data)}
                              value={data.quantity ? data.quantity : null}
                              disabled={checkOrder ? true : false}
                            />
                          </td>
                          <td>{_.get(data, "unitName", "") || _.get(data, "unit", "")}</td>
                          <td>{_.get(data, "privateName", "") || _.get(data, "pvtName", "")}</td>
                          <td><span className={ _.get(data, "privateName") && _.get(data, "privateName") !== "null" ? "pdf-optional" : ""}>{_.get(data, "product", "") || _.get(data, "style", "")}</span></td>
                          <td><span className={ _.get(data, "privateName") && _.get(data, "privateName") !== "null" ? "pdf-optional" : ""}>{_.get(data, "color", "")}</span></td>
                          <td width="110" className="showPdfData">
                            <Input 
                              ids={`materialUnitpriceItem`} 
                              validate={false}
                              handleChange={e=>handleMaterialItemChange(e, data, 'unitPrice')}
                              value={data.unitPrice ? data.unitPrice : data.price}
                              disabled={checkOrder ? true : false}
                            />
                          </td>
                          <td width="110" className="showPdfData">
                            <Input 
                              ids={`materialLinePriceItem`} 
                              validate={false}
                              handleChange={e=>handleMaterialItemChange(e, data, 'linePrice')}
                              value={data.linePrice ? data.linePrice : null}
                              disabled={checkOrder ? true : false}
                            />
                          </td>
                          { !checkOrder &&
                            <td><Button variant="link" className="text-danger p-0" onClick={e=>handleMaterialDeleteClick(data)}><Icon size={24} icon={ic_delete_outline}/></Button></td>
                          }
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={5} align="right"><div className="form-control border-0 bg-transparent py-0">Total</div></td>
                        <td>
                          <div className="form-control border-0 bg-transparent py-0 showPdfTotalData">${totalMaterialUnitPrice ? handleFormat(parseFloat(totalMaterialUnitPrice)) : parseFloat(0.00).toFixed(2)}</div>
                        </td>
                        <td><div className="form-control border-0 bg-transparent py-0 showPdfTotalData">${totalMaterialLinePrice ? handleFormat(parseFloat(totalMaterialLinePrice)) : parseFloat(0.00).toFixed(2)}</div></td>
                        { !checkOrder && <td></td> }
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <Table className="mb-0 only-for-admin">
                    <tbody>
                      <tr>
                        <td style={{'backgroundColor':'#f2f2f2'}} align="right"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Material Cost: ${handleFormat(parseFloat(totalMaterialJobCost ?? 0))}</strong></div></td>
                        <td style={{'backgroundColor':'#f2f2f2'}} align="right"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Material Profit: ${handleFormat(parseFloat(totalMaterialProfit ?? 0))}</strong></div></td>
                        <td style={{'backgroundColor':'#f2f2f2'}} align="right"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Material GPM: {handleFormat(parseFloat(totalMaterialGPM ?? 0))}%</strong></div></td>
                      </tr>
                    </tbody>
                  </Table>
                { checkOrder ? '' :
                  <div className="d-block text-center" >
                    <div data-bs-toggle="modal" id="pdfmaterialitem" role="button" className="btn btn-primary" onClick={handleClickNewMaterialItem}>
                      Add New Material Item
                    </div>
                  </div>
                }
                <hr />
                <h5 className="mb-3 pdfPageBreak">Labor</h5>
                <div className="fixTableHead">
                  <Table bordered className="mb-0 order-labor-pdf">
                    <thead>
                      <tr>
                        <th>Qty</th>
                        <th>Unit</th>
                        <th>Labor Category</th>
                        <th>Labor Name</th>
                        <th>Unit Price</th>
                        <th>Line Price</th>
                        { !checkOrder &&
                          <th id="pdfactionlabor">Actions</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {orderInstallationListData && orderInstallationListData?.length > 0 && orderInstallationListData.map((data, index) => (
                        <tr key={index}>
                          <td width="110">
                            <Input 
                              ids={`laborQuantityItem`}
                              validate={false}
                              handleChange={e=>handleLaborItemChange(e, data, 'quantity')}
                              value={data.quantity ? data.quantity : null}
                              disabled={checkOrder || data.labor?.toLowerCase() === 'odor b gone application' || data.laborName?.toLowerCase() === 'odor b gone application' ? true : false}
                            />
                          </td>
                          <td>{_.get(data, "unitName", "")}</td>
                          <td>{_.get(data, "laborCategory", "")}</td>
                          <td>{_.get(data, "labor", "") || _.get(data, "laborName", "")}</td>
                          <td width="110" className="showPdfData">
                            <Input 
                              ids={`laborUnitpriceItem`} 
                              validate={false}
                              handleChange={e=>handleLaborItemChange(e, data, 'unitPrice')}
                              value={data.unitPrice ?? data.price}
                              disabled={checkOrder ? true : false}
                            />
                            <span className="form-control" style={{'display':'none', 'backgroundColor':'#e9ecef'}}>{handleFormat(parseFloat(data?.unitCost))}</span>
                          </td>
                          <td width="110" className="showPdfData">
                            <Input 
                              ids={`laborLinePriceItem`} 
                              validate={false}
                              handleChange={e=>handleLaborItemChange(e, data, 'linePrice')}
                              value={data.linePrice ? data.linePrice : null}
                              disabled={checkOrder ? true : false}
                            />
                            <span className="form-control disabled" style={{'display':'none', 'backgroundColor':'#e9ecef'}}>{handleFormat(parseFloat(data?.lineCost))}</span>
                          </td>
                          { !checkOrder &&
                            <td><Button variant="link" className="text-danger p-0"  onClick={e=>handleLaborDeleteClick(data)}><Icon size={24} icon={ic_delete_outline}/></Button></td>
                          }
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={4} align="right"><div className="form-control border-0 bg-transparent py-0">Total</div></td>
                        <td><div className="form-control border-0 bg-transparent py-0 showPdfTotalData"><span>${totalLaborUnitPrice ? handleFormat(parseFloat(totalLaborUnitPrice)) : parseFloat(0.00).toFixed(2)}</span><span style={{'display':'none'}}>{totalLaborOrgUnitPrice ? handleFormat(parseFloat(totalLaborOrgUnitPrice)) : parseFloat(0.00).toFixed(2)}</span></div></td>
                        <td><div className="form-control border-0 bg-transparent py-0 showPdfTotalData"><span>${totalLaborLinePrice ? handleFormat(parseFloat(totalLaborLinePrice)) : parseFloat(0.00).toFixed(2)}</span><span style={{'display':'none'}}>{totalLaborOrgLinePrice ? handleFormat(parseFloat(totalLaborOrgLinePrice)) : parseFloat(0.00).toFixed(2)}</span></div></td>
                        { !checkOrder && <td></td> }
                      </tr>
                    </tbody>
                  </Table>
                </div>
                <Table className="mb-0 only-for-admin">
                  <tbody>
                    <tr>
                      <td style={{'backgroundColor':'#f2f2f2'}} align="right" className="border-0"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Labor Cost: ${handleFormat(parseFloat(totalLaborJobCost ?? 0))}</strong></div></td>
                      <td style={{'backgroundColor':'#f2f2f2'}} align="right" className="border-0"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Labor Profit: ${handleFormat(parseFloat(totalLaborProfit ?? 0))}</strong></div></td>
                      <td style={{'backgroundColor':'#f2f2f2'}} align="right" className="border-0"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Labor GPM: {handleFormat(parseFloat(totalLaborGPM ?? 0))}%</strong></div></td>
                    </tr>
                  </tbody>
                </Table>
                { checkOrder ? '' :
                  <div className="d-block text-center mb-4">
                    <div data-bs-toggle="modal" id="pdflaboritem" onClick={handleClickNewLabourItem} role="button" className="btn btn-primary">
                      Add New Labor Item
                    </div>
                  </div>
                }
                <hr />

                { !isQualityPlaced && checkOrder && customerOrderData && customerOrderData?.[0]?.rescheduleHistory?.length > 0 && customerOrderData[0].rescheduleHistory.map((customerRescheduledata, customerRescheduleIndex, rescheduleArray) => (
                  <>
                    <div className="addon-container pdfPageBreak" key={customerRescheduleIndex}>
                      <div className="text-center">
                        <h5 className="mb-3">Reschedule History #{rescheduleArray.length - customerRescheduleIndex}</h5>
                      </div>
                      <ListGroup horizontal className="mb-3">
                        <ListGroup.Item className="border-0 ps-0">
                          <strong>
                            {rescheduleArray.length - customerRescheduleIndex === 1 ? 'Original Installation Date: ' : 'Previous Installation Date: '}
                          </strong>
                          {handleFormatDate(customerRescheduledata?.orderInstallationDate)}
                        </ListGroup.Item>
                        <ListGroup.Item className="border-0"><strong>Revised Installation Date: </strong>{handleFormatDate(customerRescheduledata?.revisedInstallationDate)}</ListGroup.Item>
                        <ListGroup.Item className="border-0"><strong>Reason for Change: </strong>{customerRescheduledata?.reason}</ListGroup.Item>
                        <ListGroup.Item className="border-0"><strong>Note: </strong>{customerRescheduledata?.note}</ListGroup.Item>
                        <ListGroup.Item className="border-0"><strong>Changed By: </strong>{customerRescheduledata?.userName}</ListGroup.Item>
                      </ListGroup>
                    </div>
                    <hr />
                  </>
                ))}
                { !isQualityPlaced && checkOrder && customerOrderData && customerOrderData?.[0]?.orderAddOns?.length > 0 && orderAddonsList.map((customerAddOndata, customerAddOnIndex) => {
                  const hasAddOnRescheduleChanges = hasReschedulePendingChanges(customerAddOnIndex, customerAddOndata, 'addons');
                  const {
                    totalCost: qualityJobCost,
                    totalProfit: qualityProfit,
                    totalGPM: qualityGPM
                  } = getQualityFinancials(customerAddOndata, 'addons');
                  return (
                  <div className="addon-container" key={customerAddOnIndex}>
                    <div className="text-center">
                      <h5 className="mb-3">Add On #{customerAddOnIndex+1}</h5>
                    </div>
                    <Row className="mb-3 justify-content-center">
                      <Col sm={12} md={7} lg={7} xl={7}>
                        <ListGroup horizontal className="mb-3 flex-wrap">
                          <ListGroup.Item className="border-0 ps-0"><strong>Approved By: {customerAddOndata?.addOnDetail?.approvedBy}</strong></ListGroup.Item>
                          <ListGroup.Item className="border-0"><strong>Order Date: {handleFormatDate(customerAddOndata?.addOnDetail?.approvedDate)}</strong></ListGroup.Item>
                          <ListGroup.Item className="border-0"><strong>Entered By: {customerAddOndata?.addOnDetail?.enteredBy}</strong></ListGroup.Item>
                          <ListGroup.Item className="border-0"><strong>Description: {customerAddOndata?.addOnDetail?.description}</strong></ListGroup.Item>
                        </ListGroup>
                      </Col>
                      <Col sm={12} md={5} lg={5} xl={5}>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                          <Form.Label className="text-nowrap me-2 mb-sm-0">
                            Reschedule <div style={{ fontSize: '0.75rem', color: '#dc3545' }}>(Installation Date)</div>
                          </Form.Label>
                          <DatePicker
                            className="input-100"
                            selected={handleRescheduleDate(rescheduleAddonsData[customerAddOnIndex] || customerAddOndata?.rescheduleDate)}
                            onChange={(date)=>handleRescheduleDataChange(customerAddOnIndex, date, 'addons')}
                            minDate={new Date()}
                            placeholderText={"--/--/----"}
                            disabled={isOrderReleased}
                          />
                          { !hasDeletedItems && <>
                            <Button
                              variant={hasAddOnRescheduleChanges ? 'success' : 'secondary'}
                              className={`btn rescheduleAddonBtn rescheduleAddonBtn${customerAddOnIndex}`}
                              onClick={() => handleRescheduleSaveData(customerAddOnIndex, 'addons', customerAddOndata)}
                              disabled={!hasAddOnRescheduleChanges || isProcessing || isOrderLoading}
                            >
                              Save
                            </Button>
                            <Button variant="danger" className="btn" onClick={(e) => handleRemoveRow(customerAddOnIndex, 'addons', customerAddOndata)}>Cancel</Button>
                          </>}
                        </div>
                      </Col>
                    </Row>
                    <Table bordered responsive className="addons">
                      <thead>
                        <tr>
                          <th width="100">Qty</th>
                          <th width="100">Unit</th>
                          <th colSpan="3"></th>
                          <th width="100">Unit Price</th>
                          <th width="100">Line Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        { customerAddOndata?.products && customerAddOndata?.products?.length > 0 && customerAddOndata?.products.map((productsAddOnData, productsAddOnIndex) => (
                          <tr key={productsAddOnIndex}>
                            <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(productsAddOnData?.quantity)} disabled /></td>
                            <td>{productsAddOnData?.unitName}</td>
                            <td>{productsAddOnData?.privateName}</td>
                            <td>{productsAddOnData?.style}</td>
                            <td>{productsAddOnData?.color}</td>
                            <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(productsAddOnData?.unitPrice)} disabled /></td>
                            <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(productsAddOnData?.linePrice)} disabled /></td>
                          </tr>
                        ))}
                        { customerAddOndata?.materials && customerAddOndata?.materials?.length > 0 && customerAddOndata?.materials.map((materialAddOnData, materialAddOnIndex) => (
                          <tr key={materialAddOnIndex}>
                            <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(materialAddOnData?.quantity)} disabled /></td>
                            <td>{materialAddOnData?.unitName}</td>
                            <td>{materialAddOnData?.privateName}</td>
                            <td>{materialAddOnData?.style}</td>
                            <td>{materialAddOnData?.color}</td>
                            <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(materialAddOnData?.unitPrice)} disabled /></td>
                            <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(materialAddOnData?.linePrice)} disabled /></td>
                          </tr>
                        ))}
                        { customerAddOndata?.labors && customerAddOndata?.labors?.length > 0 && customerAddOndata?.labors.map((laborAddOnData, laborAddOnIndex) => (
                          <tr key={laborAddOnIndex}>
                            <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(laborAddOnData?.quantity)} disabled /></td>
                            <td>{laborAddOnData?.unitName}</td>
                            <td>{laborAddOnData?.laborCategory}</td>
                            <td>{laborAddOnData?.labor}</td>
                            <td></td>
                            <td className="showPdfData"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(laborAddOnData?.unitPrice)} disabled /><span className="form-control disabled" style={{'display':'none', 'backgroundColor':'#e9ecef'}}>{handleFormat(parseFloat(laborAddOnData?.unitCost))}</span></td>
                            <td className="showPdfData"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(laborAddOnData?.linePrice)} disabled /><span className="form-control disabled" style={{'display':'none', 'backgroundColor':'#e9ecef'}}>{handleFormat(parseFloat(laborAddOnData?.lineCost))}</span></td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={'5'} className="border-0 text-end"></td>
                          <td colSpan={'2'} className="border-0 text-end showPdfTotalData"><strong><h5>Total:  ${handleAddOnTotal(customerAddOndata)?.[0]}</h5></strong><strong style={{'display':'none'}}><h5>Total:  ${handleAddOnTotal(customerAddOndata)?.[1]}</h5></strong></td>
                        </tr>
                        <tr className="only-for-admin">
                          <td colSpan={7} className="border-0 text-end" align="right">
                            <Table className="mb-0">
                              <tr>
                                <td align="left" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total Job Cost: ${handleFormat(parseFloat(qualityJobCost ?? 0))}</strong></div></td>
                                <td align="left" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total Profit: ${handleFormat(parseFloat(qualityProfit ?? 0))}</strong></div></td>
                                <td align="left" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total GPM: {handleFormat(parseFloat(qualityGPM ?? 0))}%</strong></div></td>
                              </tr>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )})}
                </div>
                <div className="addon-container">
                {(!isQualityPlaced && orderShortageList && orderShortageList?.length > 0 && !JSON.parse(localStorage.getItem('isQuality'))) ? 
                  orderShortageList.map((data,idx)=> {
                  const hasShortageReasonChanges = hasShortageReasonPendingChanges(data);
                  const hasShortageRescheduleChanges = hasReschedulePendingChanges(idx, data, 'shortage');
                  const {
                    totalCost: qualityJobCost,
                    totalProfit: qualityProfit,
                    totalGPM: qualityGPM
                  } = getQualityFinancials(data, 'shortage');
                  return (
                  <div key={idx} className="pdfPageBreak">
                    <div className="text-center">
                      <h5 className="mb-3">Shortage #{idx+1}</h5>
                    </div>
                    <Row className="mb-3 justify-content-center">
                      <Col sm={12} md={7} lg={7} xl={7}>
                        <ListGroup horizontal className="mb-3 flex-wrap">
                          <ListGroup.Item className="border-0 ps-0"><strong>Called in By: {data?.orderShortageDetail?.calledInBy ? data?.orderShortageDetail?.calledInBy : ""}</strong></ListGroup.Item>
                          <ListGroup.Item className="border-0"><strong>Order Date: {data?.orderShortageDetail?.approvedDate ? formatDate(data?.orderShortageDetail?.approvedDate) : ""}</strong></ListGroup.Item>
                          <ListGroup.Item className="border-0"><strong>Entered By: {data?.orderShortageDetail?.enteredBy ? data?.orderShortageDetail?.enteredBy : ""}</strong></ListGroup.Item>
                          <ListGroup.Item className="border-0"><strong>Description: {data?.orderShortageDetail?.description ? data?.orderShortageDetail?.description : ""}</strong></ListGroup.Item>
                        </ListGroup>
                      </Col>
                      <Col sm={12} md={5} lg={5} xl={5}>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                          <Form.Label className="text-nowrap me-2 mb-sm-0" style={{ fontWeight: 600 }}>
                            Reschedule
                            <div style={{ fontSize: '0.75rem', color: '#dc3545' }}>(Installation Date)</div>
                          </Form.Label>
                          <DatePicker
                            className="input-100"
                            selected={handleRescheduleDate(rescheduleShortageData[idx] || data?.rescheduleDate)}
                            onChange={(date)=>handleRescheduleDataChange(idx, date, 'shortage')}
                            minDate={new Date()}
                            placeholderText={"--/--/----"}
                            disabled={isOrderReleased}
                          />
                          { !hasDeletedItems && <>
                            <Button
                              variant={hasShortageRescheduleChanges ? 'success' : 'secondary'}
                              className={`btn shortageBtn shortageBtn${idx}`}
                              onClick={() => handleRescheduleSaveData(idx, 'shortage', data)}
                              disabled={!hasShortageRescheduleChanges || isProcessing || isOrderLoading}
                            >
                              Save
                            </Button>
                            <Button variant="danger" className="btn" onClick={(e) => handleRemoveRow(idx, 'shortage', data)}>Cancel</Button>
                          </>}
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="form-label">
                            Reason for Shortage
                            <span className="text-danger">*</span>
                          </Form.Label>
                        </Form.Group>
                      </Col>
                      <Col md={9}>
                        <Row>
                          {data?.orderShortageReasons ? ShortageReasonsComponent(data?.orderShortageReasons, data?.jobNo) : ""}
                        </Row>
                        {!hasDeletedItems && (
                          <Row className="mt-3">
                            <Col>
                              <Button
                                variant={hasShortageReasonChanges ? 'success' : 'secondary'}
                                className={`btn saveShortageReason saveSortageReason saveSortageReason${idx}`}
                                onClick={() => handleSaveShortageReasons(data)}
                                disabled={!hasShortageReasonChanges || isProcessing || isOrderLoading}
                              >
                                Save Shortage Reasons
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                    <Table bordered responsive className="addons">
                      <thead>
                        <tr>
                          <th width="100">Qty</th>
                          <th width="100">Unit</th>
                          {/* <th width="100">Style</th> */}
                          <th colSpan="3"></th>
                          <th width="100">Unit Price</th>
                          <th width="100">Line Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(data?.orderShortageProduct && data?.orderShortageProduct?.length > 0 ) ? data?.orderShortageProduct.map((kdata) => (
                        <tr key={kdata.orderShortageProductId}>
                          <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={(kdata.quantity|| (kdata.quantity === 0)) ? parseFloat(kdata.quantity).toFixed(2) : ""} disabled /></td>
                          <td>{kdata.unitName ? kdata.unitName : ""}</td>
                          <td>{kdata.privateName ? kdata.privateName : ""}</td>
                          <td>{kdata.style ? kdata.style : ""}</td>
                          <td>{kdata.color ? kdata.color : ""}</td>
                          <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={(kdata?.unitPrice || ( kdata.unitPrice === 0))? parseFloat(kdata?.unitPrice).toFixed(2) : ""} disabled/></td>
                          <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={kdata?.linePrice || (kdata?.linePrice === 0) ? parseFloat(kdata?.linePrice).toFixed(2) : ""} disabled/></td>
                        </tr>)) : ""}
                        {(data?.orderShortageMaterial && data?.orderShortageMaterial?.length > 0 ) ? data?.orderShortageMaterial.map((kdata) => (
                        <tr key={kdata.orderShortageMaterialId}>
                          <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={(kdata.quantity|| (kdata.quantity === 0)) ? parseFloat(kdata.quantity).toFixed(2):""} disabled /></td>
                          <td>{kdata.unitName ? kdata.unitName : ""}</td>
                          <td>{kdata.privateName ? kdata.privateName : ""}</td>
                          <td>{kdata.style ? kdata.style : ""}</td>
                          <td>{kdata.color ? kdata.color : ""}</td>
                          <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={(kdata?.unitPrice || ( kdata.unitPrice === 0)) ? parseFloat(kdata?.unitPrice).toFixed(2) : ""} disabled/></td>
                          <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={kdata?.linePrice || (kdata?.linePrice === 0) ? parseFloat(kdata?.linePrice).toFixed(2) : ""} disabled/></td>
                        </tr>)) : ""}
                        {(data?.orderShortageLabor && data?.orderShortageLabor?.length > 0 ) ? data?.orderShortageLabor.map((kdata) => (
                        <tr key={kdata.orderShortageLaborId}>
                          <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={(kdata.quantity|| (kdata.quantity === 0))? parseFloat(kdata.quantity).toFixed(2):""} disabled /></td>
                          <td>{kdata.unitName ? kdata.unitName : ""}</td>
                          <td >{kdata.laborCategory ? kdata.laborCategory : ""}</td>
                          <td>{kdata.labor ? kdata.labor : ""}</td>
                          <td>{kdata.privateName ? kdata.privateName : ""}</td>
                          <td className="showPdfData"><Form.Control placeholder="" aria-label="" aria-describedby="" value={(kdata?.unitPrice || ( kdata.unitPrice === 0)) ? parseFloat(kdata?.unitPrice).toFixed(2) : ""} disabled/><span className="form-control disabled" style={{'display':'none', 'backgroundColor':'#e9ecef'}}>{parseFloat(kdata?.unitCost).toFixed(2)}</span></td>
                          <td className="showPdfData"><Form.Control placeholder="" aria-label="" aria-describedby="" value={kdata?.linePrice || (kdata?.linePrice === 0) ? parseFloat(kdata?.linePrice).toFixed(2) : ""} disabled/><span className="form-control disabled" style={{'display':'none', 'backgroundColor':'#e9ecef'}}>{parseFloat(kdata?.lineCost).toFixed(2)}</span></td>
                        </tr>)) : ""}
                        <tr>
                          <td colSpan={'5'} className="border-0 text-end"></td>
                          <td colSpan={'2'} className="border-0 text-end showPdfTotalData"><strong><h5>Total: ${calculateTotal(data?.orderShortageMaterial, data?.orderShortageProduct, data?.orderShortageLabor)?.[0]}</h5></strong><strong style={{'display':'none'}}><h5>Total:  {calculateTotal([], [], data?.orderShortageLabor)?.[1]}</h5></strong></td>
                        </tr>
                        <tr className="only-for-admin">
                          <td colSpan={7} className="border-0 text-end" align="right">
                            <Table className="mb-0">
                              <tr>
                                <td align="right" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total Job Cost: ${handleFormat(parseFloat(qualityJobCost ?? 0))}</strong></div></td>
                                <td align="right" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total Profit: ${handleFormat(parseFloat(qualityProfit ?? 0))}</strong></div></td>
                                <td align="right" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total GPM: {handleFormat(parseFloat(qualityGPM ?? 0))}%</strong></div></td>
                              </tr>
                            </Table>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                )})
                : "" }
                { !isQualityPlaced && checkOrder && customerOrderData && customerOrderData?.[0]?.orderQuality?.length > 0 && orderQualityList.map((customerQualitydata, customerQualityIndex) => {
                  const hasQualityReasonChanges = hasQualityReasonPendingChanges(customerQualitydata);
                  const hasQualityRescheduleChanges = hasReschedulePendingChanges(customerQualityIndex, customerQualitydata, 'quality');
                  const {
                    totalCost: qualityJobCost,
                    totalProfit: qualityProfit,
                    totalGPM: qualityGPM
                  } = getQualityFinancials(customerQualitydata, 'quality');
                  return (
                  <>
                    <div className="addon-container pdfPageBreak" key={customerQualityIndex}>
                      <div className="text-center">
                        <h5 className="mb-3">Quality #{customerQualityIndex+1}</h5>
                      </div>
                      <div className="d-flex gap-3 flex-wrap mb-3 justify-content-center">
                        <div className="d-block d-md-flex align-items-center">
                          <Form.Label className="text-nowrap me-2 mb-sm-0">
                            Installation Date
                          </Form.Label>
                          <DatePicker
                            className="input-100"
                            selected={handleQualityInstallationDate(customerQualitydata)}
                            minDate={new Date()}
                            placeholderText={"--/--/----"}
                            disabled={true}
                          />
                        </div>
                        <div className="d-block d-md-flex align-items-center">
                          <Form.Label className="text-nowrap me-2 mb-sm-0">
                            Status
                          </Form.Label>
                          <Select className="input-100" ids="qualityOrderedStatus" result={qualityOrderedStatusList} handleChange={e=>handleQualityStatusChange(e, customerQualitydata)} value={handleQualityStatus(customerQualitydata)} validate={false} />
                        </div>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                          <Form.Label className="text-nowrap me-2 mb-sm-0" style={{ fontWeight: 600 }}>
                            Reschedule
                            <div style={{ fontSize: '0.75rem', color: '#dc3545' }}>(Installation Date)</div>
                          </Form.Label>
                          <DatePicker
                            className="input-100"
                            selected={handleRescheduleDate(rescheduleQualityData[customerQualityIndex] || customerQualitydata?.rescheduleDate)}
                            onChange={(date)=>handleRescheduleDataChange(customerQualityIndex, date, 'quality')}
                            // minDate={new Date()}  //commented on 8 april 2026 ## task 67
                            placeholderText={"--/--/----"}
                            disabled={isOrderReleased}
                          />
                          { !hasDeletedItems && <>
                            <Button
                              variant={hasQualityRescheduleChanges ? 'success' : 'secondary'}
                              className={`btn qualityBtn qualityBtn${customerQualityIndex}`}
                              onClick={() => handleRescheduleSaveData(customerQualityIndex, 'quality', customerQualitydata)}
                              disabled={!hasQualityRescheduleChanges || isProcessing || isOrderLoading}
                            >
                              Save
                            </Button>
                            <Button variant="danger" className="btn" onClick={(e) => handleRemoveRow(customerQualityIndex, 'quality', customerQualitydata)}>Cancel</Button>
                          </>}
                        </div>
                      </div>
                      <ListGroup horizontal className="mb-3 flex-wrap">
                        <ListGroup.Item className="border-0 ps-0"><strong>Called In By: {customerQualitydata?.orderQualityDetail?.calledInBy}</strong></ListGroup.Item>
                        {/* <ListGroup.Item className="border-0"><strong>Date: {handleFormatDate(customerQualitydata?.orderQualityDetail?.approvedDate)}</strong></ListGroup.Item> */}
                        <ListGroup.Item className="border-0"><strong>Entered By: {customerQualitydata?.orderQualityDetail?.enteredBy}</strong></ListGroup.Item>
                        <ListGroup.Item className="border-0"><strong>Description: {customerQualitydata?.orderQualityDetail?.description}</strong></ListGroup.Item>
                      </ListGroup>
                      <Row className="mb-3 justify-content-center">
                        <Col md={3}>
                          <Form.Group>
                            <Form.Label className="form-label">
                              Reason for Quality
                              <span className="text-danger">*</span>
                            </Form.Label>
                          </Form.Group>
                        </Col>
                        <Col md={9}>
                          <Row>
                            {customerQualitydata?.orerQaulityReason ? handleQualityReasons(customerQualitydata?.orerQaulityReason, customerQualitydata?.jobNo) : ""}
                          </Row>
                          {!hasDeletedItems && (
                            <Row className="mt-3">
                              <Col>
                                <Button
                                  variant={hasQualityReasonChanges ? 'success' : 'secondary'}
                                  className={`btn saveQualityReason saveQualityReason${customerQualityIndex}`}
                                  onClick={() => handleSaveQualityReasons(customerQualitydata)}
                                  disabled={!hasQualityReasonChanges || isProcessing || isOrderLoading}
                                >
                                  Save Quality Reasons
                                </Button>
                              </Col>
                            </Row>
                          )}
                        </Col>
                      </Row>
                      <Row className="justify-content-center my-3">
                        <Col md={7}>
                          <div className="plan-img">
                            <img className="img-fluid view-img quantity-plan" src={customerQualitydata?.orderQualityDetail?.floorPlanImage} />
                          </div>
                        </Col>
                      </Row>
                      <div className="mb-3">
                        <Table bordered responsive className="addons">
                          <thead>
                            <tr>
                              <th width="100">Qty</th>
                              <th width="100">Unit</th>
                              <th colSpan="1">Private Name</th>
                              <th colSpan="1">Style</th>
                              <th colSpan="1">Color</th>
                              <th width="100">Unit Price</th>
                              <th width="100">Line Price</th>
                              {/* <th width="100">Actions</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            { customerQualitydata?.orderQualityProduct && customerQualitydata?.orderQualityProduct?.length > 0 && customerQualitydata?.orderQualityProduct.map((QualityAddOnData, QualityAddOnIndex) => (
                              <tr key={QualityAddOnIndex}>
                                <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(QualityAddOnData?.quantity)} disabled /></td>
                                <td>{QualityAddOnData?.unitName}</td>
                                <td>{QualityAddOnData?.privateName}</td>
                                <td>{QualityAddOnData?.style}</td>
                                <td>{QualityAddOnData?.color}</td>
                                <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(QualityAddOnData?.unitPrice)} disabled /></td>
                                <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(QualityAddOnData?.linePrice)} disabled /></td>
                                {/* <td><Button variant="link" className="text-danger p-0"><Icon size={24} icon={ic_delete_outline}/></Button></td> */}
                              </tr>
                            ))}
                            { customerQualitydata?.orderQualityMaterial && customerQualitydata?.orderQualityMaterial?.length > 0 && customerQualitydata?.orderQualityMaterial.map((materialQualityData, materialQualityIndex) => (
                              <tr key={materialQualityIndex}>
                                <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(materialQualityData?.quantity)} disabled /></td>
                                <td>{materialQualityData?.unitName}</td>
                                <td>{materialQualityData?.privateName}</td>
                                <td>{materialQualityData?.style}</td>
                                <td>{materialQualityData?.color}</td>
                                <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(materialQualityData?.unitPrice)} disabled /></td>
                                <td className="hideMaterial"><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(materialQualityData?.linePrice)} disabled /></td>
                                {/* <td><Button variant="link" className="text-danger p-0"><Icon size={24} icon={ic_delete_outline}/></Button></td> */}
                              </tr>
                            ))}
                            { customerQualitydata?.orderQualityLabor && customerQualitydata?.orderQualityLabor?.length > 0 && customerQualitydata?.orderQualityLabor.map((laborQualityData, laborQualityIndex) => (
                              <tr key={laborQualityIndex}>
                                <td><Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(laborQualityData?.quantity)} disabled /></td>
                                <td>{laborQualityData?.unitName}</td>
                                <td>{laborQualityData?.laborCategory}</td>
                                <td>{laborQualityData?.labor}</td>
                                <td></td>
                                <td className="showPdfData">
                                  <Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(laborQualityData?.unitPrice)} disabled />
                                  <span className="form-control disabled" style={{'display':'none', 'backgroundColor':'#e9ecef'}}>{handleFormat(parseFloat(laborQualityData?.unitCost))}</span>
                                </td>
                                <td className="showPdfData">
                                  <Form.Control placeholder="" aria-label="" aria-describedby="" value={handleFormat(laborQualityData?.linePrice)} disabled />
                                  <span className="form-control disabled" style={{'display':'none', 'backgroundColor':'#e9ecef'}}>{handleFormat(parseFloat(laborQualityData?.lineCost))}</span>
                                </td>
                                {/* <td><Button variant="link" className="text-danger p-0"><Icon size={24} icon={ic_delete_outline}/></Button></td> */}
                              </tr>
                            ))}
                            <tr>
                              <td colSpan={'5'} className="text-end"><strong>Total</strong></td>
                              <td colSpan={'1'} className="text-start showPdfTotalData"><strong>${handleQualityTotal(customerQualitydata, 'unitPrice')}</strong><strong style={{'display':'none'}}>${handleQualityTotal(customerQualitydata, 'unitCost')}</strong></td>
                              <td colSpan={'1'} className="text-start showPdfTotalData"><strong>${handleQualityTotal(customerQualitydata, 'linePrice')}</strong><strong style={{'display':'none'}}>${handleQualityTotal(customerQualitydata, 'lineCost')}</strong></td>
                            </tr>
                            <tr className="only-for-admin">
                              <td colSpan={7} className="border-0 text-end" align="right">
                                <Table className="mb-0">
                                  <tr>
                                    <td align="right" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total Job Cost: ${handleFormat(parseFloat(qualityJobCost ?? 0))}</strong></div></td>
                                    <td align="right" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total Profit: ${handleFormat(parseFloat(qualityProfit ?? 0))}</strong></div></td>
                                    <td align="right" className="border-0 text-end"><div className="form-control border-0 bg-transparent py-0 pdf-optional"><strong>Total GPM: {handleFormat(parseFloat(qualityGPM ?? 0))}%</strong></div></td>
                                  </tr>
                                </Table>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </div>
                    <hr />
                  </>
                )})}
                { !checkOrder &&
                  <div className="d-block text-center mb-4">
                    <div data-bs-toggle="modal" role="button" id="submitpdf" className="btn btn-primary me-2" onClick={JSON.parse(localStorage.getItem("Existing-Orders-Page")) === true ? handleQualitySaveClick : handleSaveClick}>Submit</div>
                    <div data-bs-toggle="modal" role="button" id="pdcancel" className="btn btn-primary" onClick={handleCancelClick}>Cancel</div>
                  </div>
                }
              </div>
            </Card.Body>
          </Card>)
        })}
  		</Container>
      {materialContractModalOpen && !laborContractModalOpen &&
        <PricingContract
          className="mb-2"
          storeId={customerData[0].storeId}
          contactInfoId={[contactInfoId]}
          pricingContractModalOpen={pricingContractModalOpen}
          showPricingContractModal={showPricingContractModal}
          hidePricingContractModal={hidePricingContractModal}
          isContractPricingAdded={customerData[0]?.isContractPricingAdded}
          changeReducerState={changeReducerState}
          handleUpdateCustomerDetail={handleUpdateCustomerDetail}
          materialContractModalOpen={materialContractModalOpen}
          orderInstallationDetailId={customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId}
          saveContractForOrderDetails={saveContractForOrderDetails}
          unitId={unitId}
          jobNum={jobNum}
          setLsUpdate={setLsUpdate}
          lsUpdate={lsUpdate}
          setLsLaborUpdate={setLsLaborUpdate}
          lsLaborUpdate={lsLaborUpdate}
          lsLaborMaterialUpdate={lsLaborMaterialUpdate}
          deleteOrderData={deleteOrderData}
          generateKey={generateKey}
          checkOrder={checkOrder}
          preserveSelectionsOnBack={!checkOrder}
        />
      }
      {laborContractModalOpen && !materialContractModalOpen ? (
        <PricingContract
          className="mb-2"
          storeId={customerData[0].storeId}
          contactInfoId={[contactInfoId]}
          pricingContractModalOpen={pricingContractModalOpen}
          showPricingContractModal={showPricingContractModal}
          hidePricingContractModal={hidePricingContractModal}
          isContractPricingAdded={customerData[0].isContractPricingAdded}
          changeReducerState={changeReducerState}
          handleUpdateCustomerDetail={handleUpdateCustomerDetail}
          laborContractModalOpen={laborContractModalOpen}
          saveContractForOrderDetails={saveContractForOrderDetails}
          orderInstallationDetailId={customerOrderData[0]?.orderInstallationDetails.OrderInstallationDetailId}
          unitId={unitId}
          jobNum={jobNum}
          setLsUpdate={setLsUpdate}
          lsUpdate={lsUpdate}
          setLsLaborUpdate={setLsLaborUpdate}
          lsLaborUpdate={lsLaborUpdate}
          lsLaborMaterialUpdate={lsLaborMaterialUpdate}
          deleteOrderData={deleteOrderData}
          generateKey={generateKey}
          checkOrder={checkOrder}
          preserveSelectionsOnBack={!checkOrder}
        />
      ) : ""}
      {confirmDeleteModal && <ConfirmDelete 
        variant="primary"
        title={`order-confirmation ${deleteOrder} data`}
        showConfirmDeleteModal={showConfirmDeleteModal}
        hideConfirmDeleteModal={hideConfirmDeleteModal}
        handleConfirmDeleteSubmit={handleConfirmDeleteSubmit}
        confirmDeleteModal={confirmDeleteModal}
      />}
      {isChangeJob && (
        <ChangeJob
          className="mb-2"
          handleMakeChangeModalOpen={handleMakeChangeModalOpen}
          handleMakeChangeModalClose={handleMakeChangeModalClose}
          startDate={startDate}
          isLoading={isLoading}
          setStartDate={setStartDate}
          handleRescheduleChange={handleRescheduleChange}
          handleMakeChangeClose={handleMakeChangeClose}
          handleFetchRescheduledData={handleFetchRescheduledData}
          rescheduleData={rescheduleData}
          changeJobHeader={changeJobHeader}
          setChangeJobHeader={setChangeJobHeader}
          handleRescheduleCancel={handleRescheduleCancel}
          handleReschedule={handleReschedule}
          handleShortage={handleShortage}
          handleQuality={handleQuality}
          handleOrdering={handleOrdering}
          handleAddOn={handleAddOn}
          handleClickNewMaterialItem={handleClickNewMaterialItem}
          handleClickNewLabourItem={handleClickNewLabourItem}
          handleAddOnFormChange={handleAddOnFormChange}
          addOnData={addOnData}
          materialListData={materialListData}
          orderInstallationListData={orderInstallationListData}
          handleAddOnSubmit={handleAddOnSubmit}
          handleorderShortageSubmit={handleorderShortageSubmit}
          handleAddOnCancel={handleAddOnCancel}
          orderAddOnDetails={orderAddOnDetails}
          handleFormat={handleFormat}
          handleStateChange={handleStateChange}
          shortageReason={shortageReason}
          jobNum={jobNum}
          qualityReasons={qualityReasons}
          auth={auth}
          customerData={customerData}
          orderingUrl={orderingUrl}
          saveOrderQualityDetailRequest={saveOrderQualityDetailRequest}
          saveOrderQualityDetailData={saveOrderQualityDetailData}
          localStorageData={localStorageData}
          localStorageLaborData={localStorageLaborData}
          setLsUpdate={setLsUpdate}
          lsUpdate={lsUpdate}
          setLsLaborUpdate={setLsLaborUpdate}
          lsLaborUpdate={lsLaborUpdate}
          lsLaborMaterialUpdate={lsLaborMaterialUpdate}
          lsAllLaborMaterialCarpetData={lsAllLaborMaterialCarpetData}
          handleCustomerOrderCancel={handleCustomerOrderCancel}
          fetchOrderInstallationMaterial={fetchOrderInstallationMaterial}
          fetchOrderInstallationOrder={fetchOrderInstallationOrder}
          isAddOnSubmitted={isAddOnSubmitted}
          handleAddonButtonDisability={handleAddonButtonDisability}
        />
      )}
      {deletePropertyModalOpen &&
        <ConfirmModal
          show={deletePropertyModalOpen}
          onHide={hideConfirmChangesModal}
          onConfirm={handleConfirmSubmit}
          title={`Remove ${deletePropertyData?.dataType}?`}
          message="Are you sure?"
          dangerNote={`${deletePropertyData?.dataType} will be removed for this order.`}
        />
      }
    </MainWrapper>
  )
}



const mapStateToProps = ({ auth, customerInfo, pricingContract }) => {
	return {
		auth, customerInfo, pricingContract
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchOrderInstallationDetail: (token, jobNum, checkOrder, isDeletedOrder) => dispatch({ type: CUSTOMER_UNIT_DETAIL_REQUEST, token, jobNum, checkOrder, isDeletedOrder }),
		fetchCustomerList: (token, sort, page, paginate, listParamState, userId, salesPersonId, GrpPcId, isChecked) => dispatch({ type: CUSTOMER_LIST_REQUEST, token, sort, page, paginate, listParamState, userId, salesPersonId, GrpPcId, isChecked }),
		saveCustomerOrderDetails: (token, payload) => dispatch({ type: CUSTOMER_ORDER_DETAIL_REQUEST, token,  payload }),
    changeReducerState: () => dispatch({ type: CUSTOMER_STATE_CHANGE }),
		fetchOrderInstallationMaterial: (token, jobNum) => dispatch({ type: CUSTOMER_ORDER_MATERIAL_REQUEST, token, jobNum }),
		fetchOrderInstallationOrder: (token, jobNum) => dispatch({ type: CUSTOMER_ORDER_INSTALLATION_REQUEST, token, jobNum }),
    saveCustomerOrderDetailsForPricingContract: (token, data) => dispatch({ type: SAVE_CUSTOMER_CONTRACT_DETAILS_REQUEST, token, data }),
    deleteOrderMaterialData: (token, id, checkFlag) => dispatch({ type: CUSTOMER_ORDER_MATERIAL_DELETE_REQUEST, token, id, checkFlag }),
    deleteOrderLaborData: (token, id) => dispatch({ type: CUSTOMER_ORDER_LABOR_DELETE_REQUEST, token, id }),
    saveCustomerOrderUnitId: (token, data) => dispatch({ type: CUSTOMER_ORDER_UNIT_CHANGE_REQUEST, token, data }),
    saveCustomerOrderUnitTypeId: (token, data) => dispatch({ type: CUSTOMER_ORDER_UNIT_TYPE_CHANGE_REQUEST, token, data }),
    saveCustomerOrderRescheduleData: (token, data) => dispatch({ type: CUSTOMER_ORDER_RESCHEDULE_REQUEST, token, data }),
    fetchCustomerOrderRescheduledData: (token, id) => dispatch({ type: CUSTOMER_ORDER_RESCHEDULE_DATE_REQUEST, token, id }),
    fetchCustomerOrderAddOnDetails: (token, id) => dispatch({ type: CUSTOMER_ORDER_ADD_ON_DETAILS_REQUEST, token, id }),
    saveCustomerOrderAddOnDetails: (token, data) => dispatch({ type: CUSTOMER_ORDER_ADDON_SAVE_REQUEST, token, data }),
    getShortageReasonRequest: (token, data) => dispatch({ type: GET_SHORTAGE_REASON_REQUEST, token, data }),
    saveOrderShortageRequest: (token, data) => dispatch({ type: SAVE_ORDER_SHORTAGE_DETAIL_REQUEST, token, data }),
    updateShortageReasonRequest: (token, data) => dispatch({ type: UPDATE_SHORTAGE_REASON_REQUEST, token, data }),
    getQualityReasonRequest: (token, data) => dispatch({ type: GET_QUALITY_REASON_REQUEST, token, data }),
    saveOrderQualityDetailRequest: (token, data) => dispatch({ type: SAVE_ORDER_QUALITY_DETAIL_REQUEST, token, data }),
    saveQualityOrderDetail: (token, data) => dispatch({ type: SAVE_QUALITY_ORDER_DETAILS_REQUEST, token, data }),
    fetchQualityOrderDetail: (token, data) => dispatch({ type: GET_QUALITY_ORDER_REQUEST, token, data }),
    updateQualityReason: (token, data) => dispatch({ type: UPDATE_QUALITY_REASON_REQUEST, token, data }),
    updateQualityDetail: (token, data) => dispatch({ type: UPDATE_QUALITY_DETAIL_REQUEST, token, data }),
    customerOrderCancel: (token, data) => dispatch({ type: CUSTOMER_ORDER_CANCEL_REQUEST, token, data }),
    saveRescheduleOrderRequest: (token, data, eventType) => dispatch({ type: UPDATE_RESCHEDULE_DATA_REQUEST, token, data, eventType }),
    deleteSubOrder: (token, data) => dispatch({ type: SUB_ORDER_DELETE_REQUEST, token, data }),
    updateOrderDetail: (token, data) => dispatch({ type: UPDATE_ORDER_DETAIL_REQUEST, token, data }),
    updateChildReasonRequest: (token, data) => dispatch({ type: UPDATE_CHILD_REASON_REQUEST, token, data }),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation);
